(() => {
  const root = document.querySelector('[data-lichcards-singles-index]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  // Zichtbare teksten komen als data-attribuut uit de sectie; NL is de terugval.
  const numberLocale = document.documentElement.lang || 'nl-NL';
  const interfaceLocale = String(numberLocale).slice(0, 2).toLowerCase();
  const routeRoot =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const shopRoot = routeRoot.endsWith('/') ? routeRoot : `${routeRoot}/`;
  const localeUrl = (path) => `${shopRoot}${String(path || '').replace(/^\/+/, '')}`;
  const T = {
    fileUnavailable: root.dataset.tFileUnavailable || 'Indexbestand niet beschikbaar ({status})',
    noDecompress: root.dataset.tNoDecompress || 'Deze browser ondersteunt de gecomprimeerde zoekindex niet.',
    allSets: root.dataset.tAllSets || 'Alle sets',
    allRarities: root.dataset.tAllRarities || 'Alle zeldzaamheden',
    allLanguages: root.dataset.tAllLanguages || 'Alle talen',
    allConditions: root.dataset.tAllConditions || 'Alle condities',
    allEditions: root.dataset.tAllEditions || 'Alle edities',
    allFinishes: root.dataset.tAllFinishes || 'Alle afwerkingen',
    allGraders: root.dataset.tAllGraders || 'Alle graders',
    allGradeScores: root.dataset.tAllGradeScores || 'Alle cijfers',
    allStockAmounts: root.dataset.tAllStockAmounts || 'Elk aantal',
    finishStandard: root.dataset.tFinishStandard || 'Standaard',
    finishFoilHolo: root.dataset.tFinishFoilHolo || 'Foil / Holo',
    finishReverseHolo: root.dataset.tFinishReverseHolo || 'Reverse Holo',
    finishColdFoil: root.dataset.tFinishColdFoil || 'Cold Foil',
    finishRainbowFoil: root.dataset.tFinishRainbowFoil || 'Rainbow Foil',
    finishRefractor: root.dataset.tFinishRefractor || 'Refractor',
    editionStandard: root.dataset.tEditionStandard || 'Normaal / unlimited',
    editionFirst: root.dataset.tEditionFirst || '1st Edition',
    editionLimited: root.dataset.tEditionLimited || 'Limited Edition',
    editionParallel: root.dataset.tEditionParallel || 'Parallel',
    editionSigned: root.dataset.tEditionSigned || 'Gesigneerd',
    stockAtLeast: root.dataset.tStockAtLeast || '{count}+ exemplaren',
    result: root.dataset.tResult || 'resultaat',
    results: root.dataset.tResults || 'resultaten',
    add: root.dataset.tAdd || 'Toevoegen',
    soldOut: root.dataset.tSoldOut || 'Uitverkocht',
    variantsCount: root.dataset.tVariantsCount || '{count} varianten',
    loadMoreRemaining: root.dataset.tLoadMoreRemaining || 'Meer laden ({count} resterend)',
    resultsAdded: root.dataset.tResultsAdded || '{count} extra resultaten geladen.',
    adding: root.dataset.tAdding || 'Toevoegen…',
    addFailed: root.dataset.tAddFailed || 'Toevoegen is niet gelukt.',
    added: root.dataset.tAdded || 'Toegevoegd ✓',
    addedToCart: root.dataset.tAddedToCart || 'Single is aan je winkelwagen toegevoegd.',
    loadingIndex: root.dataset.tLoadingIndex || 'Volledige singles-index laden…',
    gameLoaded: root.dataset.tGameLoaded || '{game} geladen…',
    activeProducts: root.dataset.tActiveProducts || '{count} actieve single-producten',
    searchable: root.dataset.tSearchable || '{count} actieve varianten doorzoekbaar',
    inStockTotal: root.dataset.tInStockTotal || '{count} singles op voorraad',
    searchReady: root.dataset.tSearchReady || 'De zoekfunctie is klaar.',
    viewAllResults: root.dataset.tViewAllResults || 'Bekijk alle {count} resultaten',
    stockOne: root.dataset.tStockOne || 'Nog 1 beschikbaar',
    stockMany: root.dataset.tStockMany || '{count} beschikbaar',
    emptyQuery: root.dataset.tEmptyQuery || 'Geen resultaten voor “{query}”.',
    moreFilters: root.dataset.tMoreFilters || 'Meer filters',
    lessFilters: root.dataset.tLessFilters || 'Minder filters',
    indexError: root.dataset.tIndexError || 'De zoekindex kon niet worden geladen: {message}',
    variantsUnavailable: root.dataset.tVariantsUnavailable || 'Varianten niet beschikbaar',
    viewResults: root.dataset.tViewResults || 'Bekijk resultaten ({count})',
    removeFilter: root.dataset.tRemoveFilter || 'Filter verwijderen: {label}',
    conditionGradedMint: root.dataset.tConditionGradedMint || 'Graded/Mint',
    retry:
      root.dataset.tRetry ||
      ({ de: 'Erneut versuchen', en: 'Try again', es: 'Reintentar', fr: 'Réessayer', it: 'Riprova', nl: 'Opnieuw proberen' })[
        String(document.documentElement.lang || 'nl').slice(0, 2).toLowerCase()
      ] ||
      'Opnieuw proberen',
    addLabel: root.dataset.tAddLabel || 'Toevoegen aan winkelwagen: {title}',
    soldOutLabel: root.dataset.tSoldOutLabel || 'Uitverkocht: {title}',
    viewProductLabel: root.dataset.tViewProductLabel || 'Bekijk kaart: {title}',
    priceLabel: root.dataset.tPriceLabel || 'Prijs: {price}',
    filterOptionCount: root.dataset.tFilterOptionCount || '{label} ({count})',
    viewCard:
      root.dataset.tViewCard ||
      ({
        de: 'Karte ansehen',
        en: 'View card',
        es: 'Ver tarjeta',
        fr: 'Voir la carte',
        it: 'Vedi carta',
        nl: 'Bekijk kaart',
      })[String(document.documentElement.lang || 'nl').slice(0, 2).toLowerCase()] ||
      'Bekijk kaart',
  };

  const config = JSON.parse(root.querySelector('[data-index-config]').textContent);
  const remoteSearchEnabled = true;
  const remoteSearchEndpoint = 'https://lichcards-singles-search.sweet-sea-d66e.workers.dev/search';
  let setSymbolMap = { pokemon: {} };
  const loadSetSymbolMap = async () => {
    const url = String(config.setSymbolsUrl || '');
    if (!url) return setSymbolMap;
    try {
      const response = await fetch(url, {
        credentials: 'same-origin',
        cache: 'force-cache',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return setSymbolMap;
      const payload = await response.json();
      if (payload?.version === 1 && payload.pokemon && typeof payload.pokemon === 'object') {
        setSymbolMap = payload;
      }
    } catch (_error) {
      // De dropdown blijft bruikbaar met setcodebadges als de symbolenlijst niet kan laden.
    }
    return setSymbolMap;
  };
  const fallbackGames = Array.isArray(config.games) ? config.games : [];
  const supplementalGameConfigs = Array.isArray(config.supplementalGames)
    ? config.supplementalGames
    : [];
  const gamesContainer = root.querySelector('.lc-index__games');
  let gameButtons = [];
  let gameCountElements = new Map();
  let validGames = new Set();
  let gameLogoMap = {};
  const decorateGameControls = () => {
    for (const button of gameButtons) {
      if (!button.querySelector('.lc-index__game-name')) {
        const name = document.createElement('span');
        name.className = 'lc-index__game-name';
        name.textContent = button.dataset.gameLabel || button.textContent.trim();
        Array.from(button.childNodes).filter((node) => node.nodeType === Node.TEXT_NODE)
          .forEach((node) => node.remove());
        button.prepend(name);
      }
      const logo = gameLogoMap[button.dataset.game];
      if (!logo?.src || button.querySelector('.lc-index__game-logo')) continue;
      try {
        if (new URL(logo.src).protocol !== 'https:') continue;
      } catch (_error) { continue; }
      const image = document.createElement('img');
      image.className = 'lc-index__game-logo';
      image.src = logo.src;
      image.alt = '';
      image.setAttribute('aria-hidden', 'true');
      image.width = 44;
      image.height = 28;
      image.decoding = 'async';
      image.referrerPolicy = 'no-referrer';
      image.addEventListener('error', () => image.remove(), { once: true });
      button.prepend(image);
    }
  };
  const loadGameLogos = async () => {
    // Singles-ronde 25-09-2026: logo's staan als thema-bestanden in de sectie (inline JSON);
    // geen los JSON-bestand en geen 12 externe sites meer.
    const inlineLogos = root.querySelector('[data-game-logos]');
    if (inlineLogos) {
      try {
        const payload = JSON.parse(inlineLogos.textContent);
        if (payload?.version === 1 && payload.games && typeof payload.games === 'object') {
          gameLogoMap = payload.games;
          decorateGameControls();
        }
      } catch (_error) {
        // Spelnamen blijven zichtbaar zonder logo.
      }
      return;
    }
    if (!root.dataset.gameLogosUrl) return;
    try {
      const response = await fetch(root.dataset.gameLogosUrl, { credentials: 'same-origin', cache: 'force-cache' });
      if (!response.ok) return;
      const payload = await response.json();
      if (payload?.version !== 1 || !payload.games || typeof payload.games !== 'object') return;
      gameLogoMap = payload.games;
      decorateGameControls();
    } catch (_error) {
      // Spelnamen blijven beschikbaar wanneer een logo niet kan laden.
    }
  };
  const refreshGameControls = () => {
    gameButtons = Array.from(root.querySelectorAll('[data-game]'));
    gameCountElements = new Map(
      gameButtons.map((button) => [button.dataset.game, button.querySelector('[data-game-count]')]),
    );
    validGames = new Set(gameButtons.map((button) => button.dataset.game));
    decorateGameControls();
  };
  refreshGameControls();
  const cloudflareManifestUrl =
    'https://lichcards-singles-index.sweet-sea-d66e.workers.dev/singles-index/current.json';
  const cloudflareOrigin = new URL(cloudflareManifestUrl).origin;

  const normalizedGame = (game, { cloudflareOnly = false } = {}) => {
    if (!game || typeof game !== 'object') return null;
    const slug = typeof game.slug === 'string' ? game.slug.trim() : '';
    const label = typeof game.label === 'string' ? game.label.trim() : slug;
    if (!['binary', 'base64'].includes(game.encoding)) return null;
    const encoding = game.encoding;
    const urls = Array.isArray(game.urls)
      ? game.urls
          .map((url) => {
            try {
              return new URL(url, window.location.origin);
            } catch (_error) {
              return null;
            }
          })
          .filter(
            (url) =>
              url &&
              url.protocol === 'https:' &&
              (!cloudflareOnly ||
                (url.origin === cloudflareOrigin &&
                  /^\/singles-index\/generations\/[^/]+\/[^/]+\.json\.gz$/.test(url.pathname))),
          )
          .map(String)
      : [];
    if (!slug || !label || !urls.length) return null;
    return { ...game, slug, label, encoding, urls };
  };

  const normalizeGames = (games, options) => {
    const seen = new Set();
    return (Array.isArray(games) ? games : [])
      .map((game) => normalizedGame(game, options))
      .filter((game) => {
        if (!game || seen.has(game.slug)) return false;
        seen.add(game.slug);
        return true;
      });
  };

  const normalizedSupplementalSource = (source) => {
    if (!source || typeof source !== 'object') return null;
    const kind = String(source.kind || '');
    const productType = String(source.productType || '').trim();
    if (!['collection-products-json', 'product-js'].includes(kind) || !productType) return null;
    const urls = (Array.isArray(source.urls) ? source.urls : [])
      .map((value) => {
        try {
          const url = new URL(value, window.location.origin);
          if (
            url.origin !== window.location.origin ||
            url.username ||
            url.password ||
            url.hash
          ) return null;
          if (kind === 'product-js') {
            if (!/^\/products\/[a-z0-9][a-z0-9-]*\.js$/.test(url.pathname) || url.search) {
              return null;
            }
          } else {
            if (!/^\/collections\/[a-z0-9][a-z0-9-]*\/products\.json$/.test(url.pathname)) {
              return null;
            }
            if ([...url.searchParams.keys()].some((key) => !['limit', 'page'].includes(key))) {
              return null;
            }
          }
          return `${url.pathname}${url.search}`;
        } catch (_error) {
          return null;
        }
      })
      .filter(Boolean);
    if (!urls.length || (kind === 'collection-products-json' && urls.length !== 1)) return null;
    return { kind, productType, urls: [...new Set(urls)] };
  };

  const normalizeSupplementalGames = (games) => {
    const seen = new Set();
    return (Array.isArray(games) ? games : [])
      .map((game) => {
        if (!game || typeof game !== 'object') return null;
        const slug = String(game.slug || '').trim();
        const label = String(game.label || slug).trim();
        const sources = (Array.isArray(game.sources) ? game.sources : [])
          .map(normalizedSupplementalSource)
          .filter(Boolean);
        const availableVariants = Math.max(0, Number(game.availableVariants) || 0);
        if (!/^[a-z0-9][a-z0-9-]*$/.test(slug) || !label || !sources.length) return null;
        return { slug, label, sources, availableVariants };
      })
      .filter((game) => {
        if (!game || seen.has(game.slug)) return false;
        seen.add(game.slug);
        return true;
      });
  };

  const mergeSupplementalGames = (games) => {
    const merged = games.map((game) => ({ ...game, supplementalSources: [] }));
    for (const supplemental of normalizeSupplementalGames(supplementalGameConfigs)) {
      let game = merged.find((candidate) => candidate.slug === supplemental.slug);
      if (!game) {
        game = {
          slug: supplemental.slug,
          label: supplemental.label,
          encoding: null,
          urls: [],
          availableVariants: 0,
          supplementalSources: [],
        };
        merged.push(game);
      }
      game.supplementalSources.push(...supplemental.sources);
      game.availableVariants =
        Math.max(0, Number(game.availableVariants ?? game.variantCount ?? game.variants) || 0) +
        supplemental.availableVariants;
    }
    return merged;
  };

  const syncGameControls = (games) => {
    if (!gamesContainer) return;
    const existing = new Map(
      Array.from(gamesContainer.querySelectorAll('[data-game]')).map((button) => [
        button.dataset.game,
        button,
      ]),
    );
    for (const game of games) {
      let button = existing.get(game.slug);
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.dataset.game = game.slug;
        button.dataset.gameLabel = game.label;
        button.append(document.createTextNode(`${game.label} `));
        const count = document.createElement('span');
        count.className = 'lc-index__game-count';
        count.dataset.gameCount = '';
        count.hidden = true;
        count.setAttribute('aria-hidden', 'true');
        button.append(count);
        gamesContainer.append(button);
      }
      button.disabled = false;
      button.hidden = false;
    }
    const available = new Set(games.map((game) => game.slug));
    existing.forEach((button, slug) => {
      if (slug !== 'all' && !available.has(slug)) button.hidden = true;
    });
    refreshGameControls();
  };

  const loadCloudflareManifest = async () => {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 8000);
    try {
      const response = await fetch(cloudflareManifestUrl, {
        credentials: 'omit',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
        signal: controller.signal,
      });
      if (!response.ok) {
        throw new Error(T.variantsUnavailable);
      }
      const manifest = await response.json();
      const primaryGames = normalizeGames(manifest.games, { cloudflareOnly: true });
      if (![1, 2].includes(Number(manifest.schemaVersion)) || !primaryGames.length) {
        throw new Error(T.variantsUnavailable);
      }
      const games = mergeSupplementalGames(primaryGames);
      root.dataset.indexSource = 'cloudflare';
      root.dataset.indexGeneration = manifest.generationId || manifest.generation || '';
      return { ...manifest, games, source: 'cloudflare' };
    } catch (error) {
      const primaryGames = normalizeGames(fallbackGames);
      if (!primaryGames.length) throw error;
      const games = mergeSupplementalGames(primaryGames);
      root.dataset.indexSource = 'shopify-fallback';
      root.dataset.indexGeneration = 'shopify-fallback';
      return {
        schemaVersion: 1,
        generationId: 'shopify-fallback',
        games,
        source: 'shopify-fallback',
        fallbackReason: error.message,
      };
    } finally {
      window.clearTimeout(timeout);
    }
  };
  const gameAliases = { mtg: 'magic', 'magic-the-gathering': 'magic' };
  const viewStateName = 'lichcardsSinglesView';
  const readSavedView = () => {
    try {
      const value = window.history.state?.[viewStateName];
      if (!value || value.version !== 1) return null;
      if (value.pathname !== window.location.pathname) return null;
      if (Date.now() - Number(value.savedAt || 0) > 2 * 60 * 60 * 1000) return null;
      return value;
    } catch (_error) {
      return null;
    }
  };
  const urlParams = new URLSearchParams(window.location.search);
  const requestedGame = urlParams.get('game');
  const requestedGameKey = gameAliases[requestedGame] || requestedGame;
  const urlViewKeys = [
    'q',
    'game',
    'set',
    'rarity',
    'language',
    'condition',
    'finish',
    'edition',
    'grading',
    'grader',
    'grade',
    'card',
    'availability',
    'min_stock',
    'min_price',
    'max_price',
    'sort',
  ];
  const readLocationView = () => {
    const params = new URLSearchParams(window.location.search);
    const requested = params.get('game');
    const view = {
        version: 1,
        pathname: window.location.pathname,
        savedAt: Date.now(),
        search: params.get('q') || '',
        game: gameAliases[requested] || requested || 'all',
        set: params.get('set') || '',
        rarity: params.get('rarity') || '',
        language: params.get('language') || '',
        condition: params.get('condition') || '',
        finish: params.get('finish') || '',
        edition: params.get('edition') || '',
        grading: params.get('grading') || '',
        grader: params.get('grader') || '',
        gradeScore: params.get('grade') || '',
        cardNumber: params.get('card') || '',
        availability: params.get('availability') || 'available',
        minStock: params.get('min_stock') || '',
        min: params.get('min_price') || '',
        max: params.get('max_price') || '',
        sort:
          params.get('sort') ||
          (params.get('q') || params.get('card') ? 'relevant' : 'newest'),
        shown: 0,
        scrollY: 0,
    };
    const saved = readSavedView();
    // The URL is authoritative; only reuse pagination/scroll from a matching entry.
    const fields = Object.keys(view).filter((key) =>
      !['version', 'pathname', 'savedAt', 'shown', 'scrollY'].includes(key),
    );
    if (saved && fields.every((key) => String(saved[key] ?? '').trim() === String(view[key]).trim())) {
      view.shown = Number(saved.shown) || 0;
      view.scrollY = Number(saved.scrollY) || 0;
    }
    return view;
  };
  const savedView = readLocationView();
  // The live manifest may contain games not present in the fallback config.
  const initialGame = requestedGameKey || savedView.game || 'all';
  const initialPageSize = window.matchMedia('(max-width: 820px)').matches ? 24 : 48;
  const state = {
    all: [],
    filtered: [],
    shown: 0,
    pageSize: initialPageSize,
    game: initialGame,
    query: '',
    loadedGames: new Set(),
    failedGames: new Map(),
    failedSupplements: new Map(),
    loadingGames: new Map(),
    gameRows: new Map(),
    total: 0,
    remoteReady: false,
    remotePending: false,
    remoteReset: false,
    remoteFacets: {},
    remoteGameCounts: {},
    remoteKey: '',
    remoteGeneration: '',
  };
  const manifestAvailableCounts = new Map();
  const staticAvailableCounts = new Map([
    ['all', 48251],
    ['pokemon', 14659],
    ['yugioh', 9332],
    ['magic', 20322],
    ['one-piece', 1039],
    ['lorcana', 358],
    ['dragon-ball-super', 265],
    ['digimon', 25],
    ['flesh-and-blood', 344],
    ['riftbound', 672],
    ['cardfight-vanguard', 4],
    ['weiss-schwarz', 217],
    ['gundam', 161],
    ['sports-cards', 486],
    ['disney-topps', 54],
    ['final-fantasy-tcg', 309],
    ['medabots', 4],
  ]);
  staticAvailableCounts.forEach((count, slug) => manifestAvailableCounts.set(slug, count));
  let manifestTotalAvailable = staticAvailableCounts.get('all') || 0;

  const els = {
    search: root.querySelector('[data-index-search]'),
    clearSearch: root.querySelector('[data-index-clear-search], [data-index-clear]'),
    clearFilters: root.querySelector('[data-index-clear-filters]'),
    resetAll: Array.from(root.querySelectorAll('[data-index-reset-all]')),
    status: root.querySelector('[data-index-status]'),
    eyebrow: root.querySelector('[data-index-eyebrow]'),
    count: root.querySelector('[data-index-count]'),
    grid: root.querySelector('[data-index-grid]'),
    empty: root.querySelector('[data-index-empty]'),
    loadMore: root.querySelector('[data-index-more]'),
    loadMoreStatus: root.querySelector('[data-index-more-status]'),
    set: root.querySelector('[data-filter-set]'),
    setSearch: root.querySelector('[data-filter-set-search]'),
    setPopup: root.querySelector('[data-filter-set-popup]'),
    setOptions: root.querySelector('[data-filter-set-options]'),
    setEmpty: root.querySelector('[data-filter-set-empty]'),
    setSelectedIcon: root.querySelector('[data-filter-set-selected-icon]'),
    rarity: root.querySelector('[data-filter-rarity]'),
    language: root.querySelector('[data-filter-language]'),
    condition: root.querySelector('[data-filter-condition]'),
    edition: root.querySelector('[data-filter-edition]'),
    cardNumber: root.querySelector('[data-filter-card-number]'),
    finish: root.querySelector('[data-filter-finish]'),
    grading: root.querySelector('[data-filter-grading]'),
    grader: root.querySelector('[data-filter-grader]'),
    gradeScore: root.querySelector('[data-filter-grade-score]'),
    availability: root.querySelector('[data-filter-availability]'),
    minStock: root.querySelector('[data-filter-min-stock]'),
    min: root.querySelector('[data-filter-min]'),
    max: root.querySelector('[data-filter-max]'),
    sort: root.querySelector('[data-index-sort]'),
    filterTrigger: root.querySelector('[data-index-filters-open]'),
    filterPanel: root.querySelector('[data-index-filters-panel]'),
    filterBackdrop: root.querySelector('[data-index-filters-backdrop]'),
    filterApply: root.querySelector('[data-index-filters-apply]'),
    filterCount: root.querySelector('[data-index-filter-count]'),
    activeFilters: root.querySelector('[data-index-active-filters]'),
    activeFiltersList: root.querySelector('[data-index-active-filters-list]'),
    activeFiltersClear: root.querySelector('[data-index-active-filters-clear]'),
    priceError: root.querySelector('[data-filter-price-error]'),
    emptyQuery: root.querySelector('[data-index-empty-query]'),
    moreFilters: root.querySelector('[data-index-more-filters]'),
    moreFiltersLabel: root.querySelector('[data-index-more-filters-label]'),
    filterRows: new Map(
      Array.from(root.querySelectorAll('[data-filter-row]')).map((row) => [
        row.dataset.filterRow,
        row,
      ]),
    ),
  };

  const setIndexStatus = (message, status = 'loading') => {
    els.status.textContent = message;
    els.status.dataset.state = status;
  };

  const shopCurrency = String(config.shopCurrency || config.currency || 'EUR').toUpperCase();
  const presentmentCurrency = String(config.presentmentCurrency || shopCurrency).toUpperCase();
  root.dataset.indexCurrency = shopCurrency;
  root.dataset.presentmentCurrency = presentmentCurrency;

  const notifySearchValueChange = () => {
    root.dispatchEvent(
      new CustomEvent('lichcards:singles:query-change', {
        bubbles: true,
        detail: { query: els.search.value.trim() },
      }),
    );
  };

  const analyticsSignature = new Map();
  const publishAnalytics = (name, payload = {}) => {
    const detail = {
      component: 'singles-search',
      game: state.game,
      generation: root.dataset.indexGeneration || '',
      ...payload,
    };
    try {
      root.dispatchEvent(
        new CustomEvent(`lichcards:singles:${name}`, { bubbles: true, detail }),
      );
    } catch (_error) {
      // Analytics mag de winkelervaring nooit blokkeren.
    }
    try {
      if (typeof window.Shopify?.analytics?.publish === 'function') {
        window.Shopify.analytics.publish(`lichcards_singles_${name}`, detail);
      }
    } catch (_error) {
      // Een ontbrekende of geblokkeerde analytics-consentlaag is een geldige situatie.
    }
  };

  const publishAnalyticsOnce = (name, signature, payload) => {
    if (analyticsSignature.get(name) === signature) return;
    analyticsSignature.set(name, signature);
    publishAnalytics(name, payload);
  };

  const buildSearchUrl = () => {
    const url = new URL(window.location.href);
    for (const key of urlViewKeys) url.searchParams.delete(key);
    const setParam = (key, value) => {
      const normalized = String(value ?? '').trim();
      if (normalized) url.searchParams.set(key, normalized);
    };
    const query = els.search.value.trim();
    setParam('q', query);
    if (state.game !== 'all') setParam('game', state.game);
    setParam('set', els.set.value);
    setParam('rarity', els.rarity.value);
    setParam('language', els.language.value);
    setParam('condition', els.condition.value);
    setParam('finish', els.finish.value);
    setParam('edition', els.edition.value);
    setParam('grading', els.grading.value);
    setParam('grader', els.grader.value);
    setParam('grade', els.gradeScore.value);
    setParam('card', els.cardNumber.value);
    if (els.availability.value !== 'available') setParam('availability', els.availability.value);
    setParam('min_stock', els.minStock.value);
    setParam('min_price', els.min.value);
    setParam('max_price', els.max.value);
    const defaultSort = query || els.cardNumber.value.trim() ? 'relevant' : 'newest';
    if (els.sort.value && els.sort.value !== defaultSort) setParam('sort', els.sort.value);
    url.searchParams.sort();
    return url;
  };

  const canonicalHistoryUrl = (value) => {
    const url = new URL(value, window.location.href);
    url.searchParams.sort();
    return url.href;
  };
  let historyDraft = null;
  const historyStateObject = () =>
    window.history.state && typeof window.history.state === 'object'
      ? window.history.state
      : {};
  const beginHistoryDraft = () => {
    cancelSavedViewRestore();
    if (historyDraft) return;
    try {
      const existing = historyStateObject();
      const view = existing[viewStateName];
      historyDraft = {
        url: window.location.href,
        state: view
          ? { ...existing, [viewStateName]: { ...view, scrollY: Math.max(0, window.scrollY || 0) } }
          : existing,
      };
    } catch (_error) {
      // Search must keep working even when history access is restricted.
    }
  };

  const persistView = ({ mode = 'replace' } = {}) => {
    try {
      const snapshot = {
        version: 1,
        pathname: window.location.pathname,
        savedAt: Date.now(),
        search: els.search.value,
        game: state.game,
        set: els.set.value,
        rarity: els.rarity.value,
        language: els.language.value,
        condition: els.condition.value,
        edition: els.edition.value,
        cardNumber: els.cardNumber.value,
        finish: els.finish.value,
        grading: els.grading.value,
        grader: els.grader.value,
        gradeScore: els.gradeScore.value,
        availability: els.availability.value,
        minStock: els.minStock.value,
        min: els.min.value,
        max: els.max.value,
        sort: els.sort.value,
        shown: pendingSavedShown ?? (remoteSearchEnabled && state.remoteReset ? state.pageSize : state.shown),
        scrollY: pendingSavedScrollY ?? Math.max(0, window.scrollY || 0),
      };
      const url = buildSearchUrl();
      const existingState = historyStateObject();
      const nextState = { ...existingState, [viewStateName]: snapshot };
      const baseline = historyDraft || { url: window.location.href, state: existingState };
      const changed = canonicalHistoryUrl(url) !== canonicalHistoryUrl(baseline.url);
      if (mode === 'commit' && changed) {
        // Typing replaces one draft entry. Commit restores its baseline, then adds
        // one navigable search/filter step rather than one entry per keystroke.
        if (historyDraft) window.history.replaceState(baseline.state, '', baseline.url);
        else {
          const previous = existingState[viewStateName];
          if (previous) window.history.replaceState({
            ...existingState,
            [viewStateName]: { ...previous, scrollY: snapshot.scrollY },
          }, '', window.location.href);
        }
        try {
          window.history.pushState(nextState, '', url);
        } catch (_error) {
          // If push is blocked, retain the current query/URL instead of reverting it.
          window.history.replaceState(nextState, '', url);
        }
      } else {
        window.history.replaceState(nextState, '', url);
      }
      if (mode === 'commit' || !changed) historyDraft = null;
    } catch (_error) {
      // History state can be unavailable in privacy-restricted browsers.
    }
  };

  const normalize = (value) =>
    String(value || '')
      .normalize('NFKD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase();

  const normalizeSearch = (value) =>
    normalize(value)
      .replace(/['’]/g, '')
      .replace(/[^\p{L}\p{N}]+/gu, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  const normalizeKey = (value) => normalizeSearch(value).replace(/\s+/g, '-');

  // Zeldzaamheden blijven Engels (Common, Uncommon, Rare …), zoals op de kaarten zelf (25-09-2026).
  const facetLabelMaps = {
    nl: {
      game: { 'sports-cards': 'Sportkaarten' },
      language: { english: 'Engels', japanese: 'Japans', german: 'Duits', french: 'Frans', italian: 'Italiaans', spanish: 'Spaans', portuguese: 'Portugees', korean: 'Koreaans', chinese: 'Chinees', 'simplified-chinese': 'Vereenvoudigd Chinees', 'traditional-chinese': 'Traditioneel Chinees', czech: 'Tsjechisch', dutch: 'Nederlands', russian: 'Russisch', indonesian: 'Indonesisch' },
      condition: { mint: 'Nieuwstaat', 'near-mint': 'Near Mint', excellent: 'Lichte gebruikssporen', 'lightly-played': 'Zichtbaar gebruikt', 'moderately-played': 'Licht gespeeld', 'heavily-played': 'Zwaar gespeeld', damaged: 'Sterk beschadigd' },
    },
    de: {
      game: { 'sports-cards': 'Sportkarten' },
      language: { english: 'Englisch', japanese: 'Japanisch', german: 'Deutsch', french: 'Französisch', italian: 'Italienisch', spanish: 'Spanisch', portuguese: 'Portugiesisch', korean: 'Koreanisch', chinese: 'Chinesisch', 'simplified-chinese': 'Vereinfachtes Chinesisch', 'traditional-chinese': 'Traditionelles Chinesisch', czech: 'Tschechisch', dutch: 'Niederländisch', russian: 'Russisch', indonesian: 'Indonesisch' },
      condition: { mint: 'Neuwertig', 'near-mint': 'Nahezu neuwertig', excellent: 'Sehr gut', 'lightly-played': 'Leicht gespielt', 'moderately-played': 'Mäßig gespielt', 'heavily-played': 'Stark gespielt', damaged: 'Beschädigt' },
    },
    fr: {
      game: { 'sports-cards': 'Cartes de sport' },
      language: { english: 'Anglais', japanese: 'Japonais', german: 'Allemand', french: 'Français', italian: 'Italien', spanish: 'Espagnol', portuguese: 'Portugais', korean: 'Coréen', chinese: 'Chinois', 'simplified-chinese': 'Chinois simplifié', 'traditional-chinese': 'Chinois traditionnel', czech: 'Tchèque', dutch: 'Néerlandais', russian: 'Russe', indonesian: 'Indonésien' },
      condition: { mint: 'Neuve', 'near-mint': 'Quasi neuve', excellent: 'Excellente', 'lightly-played': 'Légèrement jouée', 'moderately-played': 'Modérément jouée', 'heavily-played': 'Très jouée', damaged: 'Endommagée' },
    },
    es: {
      game: { 'sports-cards': 'Cartas deportivas' },
      language: { english: 'Inglés', japanese: 'Japonés', german: 'Alemán', french: 'Francés', italian: 'Italiano', spanish: 'Español', portuguese: 'Portugués', korean: 'Coreano', chinese: 'Chino', 'simplified-chinese': 'Chino simplificado', 'traditional-chinese': 'Chino tradicional', czech: 'Checo', dutch: 'Neerlandés', russian: 'Ruso', indonesian: 'Indonesio' },
      condition: { mint: 'Nueva', 'near-mint': 'Casi nueva', excellent: 'Excelente', 'lightly-played': 'Poco jugada', 'moderately-played': 'Moderadamente jugada', 'heavily-played': 'Muy jugada', damaged: 'Dañada' },
    },
    it: {
      game: { 'sports-cards': 'Carte sportive' },
      language: { english: 'Inglese', japanese: 'Giapponese', german: 'Tedesco', french: 'Francese', italian: 'Italiano', spanish: 'Spagnolo', portuguese: 'Portoghese', korean: 'Coreano', chinese: 'Cinese', 'simplified-chinese': 'Cinese semplificato', 'traditional-chinese': 'Cinese tradizionale', czech: 'Ceco', dutch: 'Olandese', russian: 'Russo', indonesian: 'Indonesiano' },
      condition: { mint: 'Nuova', 'near-mint': 'Quasi nuova', excellent: 'Eccellente', 'lightly-played': 'Poco giocata', 'moderately-played': 'Moderatamente giocata', 'heavily-played': 'Molto giocata', damaged: 'Danneggiata' },
    },
  };
  const localizedFacetLabel = (facet, key, fallback) =>
    facetLabelMaps[interfaceLocale]?.[facet]?.[normalizeKey(key || fallback)] || fallback;
  const tokenize = (value) => [...new Set(normalizeSearch(value).split(' ').filter(Boolean))];
  const compactKey = (value) => normalizeSearch(value).replace(/[^\p{L}\p{N}]/gu, '');

  const asObject = (value) =>
    value && typeof value === 'object' && !Array.isArray(value) ? value : null;
  const firstDefined = (...values) =>
    values.find((value) => value !== undefined && value !== null && value !== '');
  const readExplicitFacet = (record, names) => {
    const facets = asObject(record?.facets) || asObject(record?.f) || {};
    for (const name of names) {
      const value = firstDefined(record?.[name], facets[name]);
      if (value !== undefined) return value;
    }
    return undefined;
  };
  const facetParts = (value, fallbackLabel = '') => {
    const object = asObject(value);
    const label = String(
      firstDefined(object?.label, object?.name, object?.value, object?.key, value, fallbackLabel) ||
        '',
    ).trim();
    const key = String(firstDefined(object?.key, object?.value, label) || '').trim();
    return { key: normalizeKey(key), label: label || fallbackLabel || key };
  };
  const explicitBoolean = (record, names) => {
    const raw = readExplicitFacet(record, names);
    const value = firstDefined(asObject(raw)?.value, asObject(raw)?.key, raw);
    if (typeof value === 'boolean') return value;
    if (
      value === 1 ||
      ['1', 'true', 'available', 'in-stock', 'in_stock', 'orderable'].includes(String(value).toLowerCase())
    ) {
      return true;
    }
    if (
      value === 0 ||
      ['0', 'false', 'unavailable', 'sold-out', 'sold_out', 'not-orderable'].includes(
        String(value).toLowerCase(),
      )
    ) {
      return false;
    }
    return undefined;
  };
  const amountValue = (value) => {
    const object = asObject(value);
    const raw = firstDefined(object?.amount, object?.value, value);
    const parsed = typeof raw === 'number' ? raw : Number(String(raw || '').replace(',', '.'));
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
  };

  const rarityValuePattern =
    /(?:common|uncommon|rare|mythic|promo|parallel|special|leader|token|energy|land|fixed|golden baller|fan favourite(?:\s*-\s*(?:blue|red|pink) parallel)?|limited edition|elite cut|magician|dominator|titan|momentum|rising star|nordic edition|kick-off)$/i;
  const structuralPattern =
    /^(english|japanese|german|french|italian|spanish|portuguese|korean|chinese|simplified chinese|traditional chinese|czech|dutch|russian|indonesian|near mint|nm|mint|excellent|good|slightly played|lightly played|light played|moderately played|played|heavily played|poor|damaged|normal|foil|foil normal|reverse holo|reverse-holo|1st[-\s]?edition|limited[-\s]?edition|signed|unlimited|graded|fixed)$/i;
  const conditionOrder = ['Mint', 'Near Mint', 'Excellent', 'Lightly Played', 'Moderately Played', 'Heavily Played', 'Damaged'];
  const conditionRank = new Map(conditionOrder.map((condition, index) => [condition, index]));
  const languagePattern =
    /^(english|japanese|german|french|italian|spanish|portuguese|korean|chinese|simplified chinese|traditional chinese|czech|dutch|russian|indonesian)$/i;
  const conditionPattern =
    /^(mint|near mint|nm|excellent|good|slightly played|lightly played|light played|moderately played|played|heavily played|poor|damaged)$/i;
  const conditionAliases = new Map([
    ['nm', 'Near Mint'],
  ]);
  const finishOrder = [
    'standard',
    'foil-holo',
    'reverse-holo',
    'cold-foil',
    'rainbow-foil',
    'refractor',
  ];
  const finishLabels = {
    standard: T.finishStandard,
    'foil-holo': T.finishFoilHolo,
    'reverse-holo': T.finishReverseHolo,
    'cold-foil': T.finishColdFoil,
    'rainbow-foil': T.finishRainbowFoil,
    refractor: T.finishRefractor,
  };
  const editionGroupOrder = [
    'standard',
    'first-edition',
    'limited-edition',
    'parallel',
    'signed',
  ];
  const editionGroupLabels = {
    standard: T.editionStandard,
    'first-edition': T.editionFirst,
    'limited-edition': T.editionLimited,
    parallel: T.editionParallel,
    signed: T.editionSigned,
  };
  const gradePattern =
    /^(PSA|BGS|CGC|SGC|GRAAD|ACE|BECKETT|BCCG|GMA|AGS|HGA|MNT|KSA|PCA)\s*(\d+(?:[.,]\d+)?)/i;
  const gradeSearchPattern =
    /\b(PSA|BGS|CGC|SGC|GRAAD|ACE|BECKETT|BCCG|GMA|AGS|HGA|MNT|KSA|PCA)\s*(\d+(?:[.,]\d+)?)/i;
  const finishEditionTagPattern =
    /^(?:normal|unlimited|foil(?:\s+normal)?|holo(?:\s+rare)?|reverse[-\s]?holo(?:\s+normal)?|cold[-\s]?foil|rainbow[-\s]?foil|(?:.+\s+)?refractor|1st[-\s]?edition|first[-\s]?edition|limited[-\s]?edition|signed|parallel|(?:.+\s+)?parallel|momentum|elite cut)$/i;
  const gradedTagPattern = /^graded(?:\s+(?:card|cards|kaart|kaarten))?$/i;
  const isVariantStructuralTag = (value) => {
    const label = String(value || '').trim();
    return (
      languagePattern.test(label) ||
      conditionPattern.test(label) ||
      finishEditionTagPattern.test(label) ||
      gradedTagPattern.test(label) ||
      gradePattern.test(label)
    );
  };
  const escapeMarkup = (value) =>
    String(value || '').replace(
      /[&<>"']/g,
      (character) =>
        ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;',
        })[character],
    );

  const decodeBase64 = (value) => {
    const binary = window.atob(value.replace(/\s+/g, ''));
    const bytes = new Uint8Array(binary.length);
    for (let index = 0; index < binary.length; index += 1) {
      bytes[index] = binary.charCodeAt(index);
    }
    return bytes;
  };

  const decodeGzip = async (urls, encoding = 'binary') => {
    const fetchIndexFile = async (url, retry = false) => {
      let response;
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 15000);
      try {
        response = await fetch(url, {
          credentials: 'omit',
          cache: retry ? 'reload' : 'default',
          signal: controller.signal,
        });
      } catch (error) {
        if (!retry) return fetchIndexFile(url, true);
        throw error;
      } finally {
        window.clearTimeout(timeout);
      }
      if (!response.ok) {
        const retryable = response.status >= 500 || [408, 429].includes(response.status);
        if (!retry && retryable) return fetchIndexFile(url, true);
        throw new Error(T.fileUnavailable.replace('{status}', response.status));
      }
      return response;
    };
    const responses = await Promise.all(
      urls.map((url) => fetchIndexFile(url)),
    );
    if (!('DecompressionStream' in window)) {
      throw new Error(T.noDecompress);
    }
    const compressed =
      encoding === 'base64'
        ? decodeBase64((await Promise.all(responses.map((response) => response.text()))).join(''))
        : await Promise.all(responses.map((response) => response.arrayBuffer()));
    const stream = new Blob(Array.isArray(compressed) ? compressed : [compressed])
      .stream()
      .pipeThrough(new DecompressionStream('gzip'));
    return JSON.parse(await new Response(stream).text());
  };

  const fetchStorefrontJson = async (url, retry = false) => {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 15000);
    let response;
    try {
      response = await fetch(url, {
        credentials: 'same-origin',
        cache: retry ? 'reload' : 'default',
        headers: { Accept: 'application/json' },
        signal: controller.signal,
      });
    } catch (error) {
      if (!retry) return fetchStorefrontJson(url, true);
      throw error;
    } finally {
      window.clearTimeout(timeout);
    }
    if (!response.ok) {
      const retryable = response.status >= 500 || [408, 429].includes(response.status);
      if (!retry && retryable) return fetchStorefrontJson(url, true);
      throw new Error(T.fileUnavailable.replace('{status}', response.status));
    }
    return response.json();
  };

  const storefrontImage = (value) => {
    const raw = typeof value === 'string' ? value : value?.src || value?.url || '';
    if (!raw) return '';
    try {
      return new URL(raw, window.location.origin).href;
    } catch (_error) {
      return '';
    }
  };

  const compactStorefrontProduct = (raw, source) => {
    if (!raw || typeof raw !== 'object') return null;
    const actualType = String(raw.product_type || raw.type || '').trim();
    if (actualType !== source.productType) return null;
    const tags = Array.isArray(raw.tags)
      ? raw.tags.map(String)
      : String(raw.tags || '')
          .split(',')
          .map((value) => value.trim())
          .filter(Boolean);
    const optionNames = (Array.isArray(raw.options) ? raw.options : []).map((option) =>
      normalizeKey(typeof option === 'string' ? option : option?.name),
    );
    const optionValue = (variant, accepted) => {
      const index = optionNames.findIndex((name) => accepted.includes(name));
      if (index < 0) return '';
      return String(variant[`option${index + 1}`] ?? variant.options?.[index] ?? '').trim();
    };
    const pricesAreCents = source.kind === 'product-js';
    const variants = (Array.isArray(raw.variants) ? raw.variants : [])
      .map((variant) => {
        const price = Number(variant?.price);
        return {
          i: String(variant?.id || ''),
          p: pricesAreCents ? price / 100 : price,
          s: Boolean(variant?.available),
          l: optionValue(variant, ['language', 'taal']),
          c: optionValue(variant, ['condition', 'conditie']),
          e: optionValue(variant, ['edition', 'finish', 'uitgave', 'afwerking']),
          m: storefrontImage(variant?.featured_image),
        };
      })
      .filter((variant) => variant.i && Number.isFinite(variant.p));
    const image = storefrontImage(raw.image || raw.featured_image || raw.images?.[0]);
    const product = {
      i: String(raw.id || ''),
      t: String(raw.title || '').trim(),
      h: String(raw.handle || '').trim(),
      a: tags,
      u: String(raw.updated_at || raw.created_at || ''),
      m: image,
      v: variants,
    };
    return product.i && product.t && product.h && variants.length ? product : null;
  };

  const loadSupplementSource = async (source) => {
    if (source.kind === 'product-js') {
      const payloads = await Promise.all(source.urls.map((url) => fetchStorefrontJson(url)));
      return payloads
        .map((payload) => compactStorefrontProduct(payload, source))
        .filter(Boolean);
    }
    const products = [];
    for (let page = 1; page <= 4; page += 1) {
      const url = new URL(source.urls[0], window.location.origin);
      url.searchParams.set('limit', '250');
      url.searchParams.set('page', String(page));
      const payload = await fetchStorefrontJson(`${url.pathname}${url.search}`);
      const batch = Array.isArray(payload?.products) ? payload.products : [];
      products.push(...batch);
      if (batch.length < 250) break;
      if (page === 4) throw new Error(T.variantsUnavailable);
    }
    return products
      .map((product) => compactStorefrontProduct(product, source))
      .filter(Boolean);
  };

  const productPayloadItems = (payload) =>
    Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.products)
        ? payload.products
        : Array.isArray(payload?.items)
          ? payload.items
          : [];

  const chooseRarity = (product) => {
    const title = normalize(product.t);
    const titleWithoutNumber = title.replace(/\s*\[[^\]]+\]\s*$/, '').trim();
    const trailingCandidates = product.a.filter((tag) =>
      titleWithoutNumber.endsWith(`(${normalize(tag)})`),
    );
    if (trailingCandidates.length) {
      return trailingCandidates.sort((a, b) => b.length - a.length)[0] || '';
    }
    const fallbackCandidates = product.a.filter(
      (tag) => rarityValuePattern.test(String(tag).trim()) && title.includes(`(${normalize(tag)})`),
    );
    return fallbackCandidates.sort((a, b) => b.length - a.length)[0] || '';
  };

  const chooseSet = (product, rarity) => {
    const game = normalize(product.gl);
    const gameCompact = compactKey(product.gl);
    const title = normalize(product.t);
    const rawCandidates = product.a.filter((tag) => {
      const value = normalize(tag);
      const valueCompact = compactKey(tag);
      return (
        value !== game &&
        valueCompact !== `${gameCompact}single` &&
        valueCompact !== `${gameCompact}singles` &&
        tag !== rarity
      );
    });
    const exactTitleSet = rawCandidates.filter((tag) =>
      title.includes(` - ${normalize(tag)} (`),
    );
    const candidates = rawCandidates.filter((tag) => !structuralPattern.test(tag));
    const inTitle = candidates.filter((tag) => title.includes(normalize(tag)));
    return (exactTitleSet.length ? exactTitleSet : inTitle.length ? inTitle : candidates).sort(
      (a, b) => b.length - a.length,
    )[0] || '';
  };

  const chooseGrade = (edition, tags = [], title = '') => {
    const explicitGraded = tags.some((tag) =>
      /^graded(?:\s+(?:card|cards|kaart|kaarten))?$/i.test(String(tag).trim()),
    );
    const match =
      String(edition || '').trim().match(gradePattern) ||
      tags
        .map((tag) => String(tag || '').trim().match(gradeSearchPattern))
        .find(Boolean) ||
      (explicitGraded ? String(title || '').trim().match(gradeSearchPattern) : null);
    if (!match) {
      return explicitGraded ? 'GRADED' : '';
    }
    const grader = match[1].toUpperCase() === 'BECKETT' ? 'BGS' : match[1].toUpperCase();
    const score = match[2].replace(',', '.').replace(/\.0$/, '');
    return `${grader} ${score}`;
  };

  const chooseEditionBadge = (edition) =>
    String(edition || '')
      .trim()
      .replace(gradePattern, '')
      .trim();

  const chooseLanguage = (variant, tags = []) => {
    const direct = String(variant.l || '').trim();
    if (languagePattern.test(direct)) return direct;
    return tags.find((tag) => languagePattern.test(String(tag).trim())) || '';
  };

  const chooseCondition = (variant, tags = []) => {
    const candidates = [variant.c, variant.l, ...tags];
    const direct = candidates
      .map((value) => String(value || '').trim())
      .find((value) => conditionPattern.test(value));
    if (!direct) return '';
    return conditionAliases.get(normalize(direct)) || direct;
  };

  const chooseFinish = (edition, tags = []) => {
    const editionValue = normalize(chooseEditionBadge(edition));
    const tagValues = tags.map((tag) => normalize(tag));
    const hasTag = (pattern) => tagValues.some((tag) => pattern.test(tag));
    if (/cold[-\s]?foil/.test(editionValue) || hasTag(/^cold[-\s]?foil$/)) return 'cold-foil';
    if (/rainbow[-\s]?foil/.test(editionValue) || hasTag(/^rainbow[-\s]?foil$/)) {
      return 'rainbow-foil';
    }
    if (/reverse[-\s]?holo/.test(editionValue) || hasTag(/^reverse[-\s]?holo$/)) {
      return 'reverse-holo';
    }
    if (/refractor/.test(editionValue) || hasTag(/refractor/)) return 'refractor';
    if (/\b(foil|holo)\b/.test(editionValue) || hasTag(/^(foil|holo rare)$/)) {
      return 'foil-holo';
    }
    return 'standard';
  };

  const chooseEditionGroup = (edition, tags = []) => {
    const value = normalize([chooseEditionBadge(edition), ...tags].join(' '));
    if (/\bsigned\b/.test(value)) return 'signed';
    if (/\b1st[-\s]?edition\b/.test(value)) return 'first-edition';
    if (/\blimited[-\s]?edition\b/.test(value)) return 'limited-edition';
    if (/\b(parallel|refractor|momentum|elite cut)\b/.test(value)) return 'parallel';
    return 'standard';
  };

  const normalizeCardNumber = (value) => normalize(value).replace(/[^a-z0-9]/g, '');

  const canonicalLanguage = (value) => {
    const label = String(value || '').trim();
    const aliases = {
      chinese: 'Chinese',
      czech: 'Czech',
      dutch: 'Dutch',
      english: 'English',
      french: 'French',
      german: 'German',
      indonesian: 'Indonesian',
      italian: 'Italian',
      japanese: 'Japanese',
      korean: 'Korean',
      portuguese: 'Portuguese',
      russian: 'Russian',
      'simplified-chinese': 'Simplified Chinese',
      spanish: 'Spanish',
      'traditional-chinese': 'Traditional Chinese',
    };
    return aliases[normalizeKey(label)] || label;
  };

  const canonicalCondition = (value) => {
    const label = String(value || '').trim();
    const aliases = {
      excellent: 'Excellent',
      good: 'Lightly Played',
      'slightly-played': 'Lightly Played',
      'lightly-played': 'Lightly Played',
      'light-played': 'Moderately Played',
      'moderately-played': 'Moderately Played',
      mint: 'Mint',
      'near-mint': 'Near Mint',
      nm: 'Near Mint',
      played: 'Heavily Played',
      'heavily-played': 'Heavily Played',
      poor: 'Damaged',
      damaged: 'Damaged',
    };
    return aliases[normalizeKey(label)] || label;
  };

  const conditionTone = (condition) => normalizeKey(condition);

  const editionTone = (edition) => {
    const value = normalize(edition);
    if (value.includes('1st edition')) return 'first-edition';
    if (/(reverse-holo|rainbow-foil|cold-foil|foil|holo)/.test(value)) return 'foil';
    if (value.includes('blue parallel')) return 'blue-parallel';
    if (value.includes('red parallel')) return 'red-parallel';
    if (value.includes('pink parallel')) return 'pink-parallel';
    if (value.includes('limited edition')) return 'limited-edition';
    if (value.includes('momentum')) return 'momentum';
    if (value.includes('signed')) return 'signed';
    if (value.includes('us edition') || value.includes('nordic edition')) return 'special';
    return 'normal';
  };

  const dataDiagnostics = { skippedProducts: 0, skippedVariants: 0, currencyMismatches: 0 };
  const normalizedFinish = (value, fallback) => {
    const key = normalizeKey(firstDefined(asObject(value)?.key, asObject(value)?.value, value, fallback));
    const aliases = {
      foil: 'foil-holo',
      holo: 'foil-holo',
      'foil-normal': 'foil-holo',
      normal: 'standard',
      'reverse-holo-normal': 'reverse-holo',
      unlimited: 'standard',
    };
    return aliases[key] || key || fallback || 'standard';
  };
  const normalizedEditionGroup = (value, fallback) => {
    const key = normalizeKey(firstDefined(asObject(value)?.key, asObject(value)?.value, value, fallback));
    const aliases = {
      '1st-edition': 'first-edition',
      first: 'first-edition',
      limited: 'limited-edition',
      normal: 'standard',
      unlimited: 'standard',
    };
    return aliases[key] || key || fallback || 'standard';
  };

  const flatten = async (products, gameDescriptor = {}) => {
    const rows = [];
    let sliceStartedAt = window.performance.now();
    let workUnits = 0;
    const productList = Array.isArray(products)
      ? products
      : Array.isArray(products?.products)
        ? products.products
        : Array.isArray(products?.items)
          ? products.items
          : [];
    for (const sourceProduct of productList) {
      workUnits += 1;
      if (workUnits >= 32) {
        workUnits = 0;
        if (window.performance.now() - sliceStartedAt >= 12) {
          await yieldToBrowser();
          sliceStartedAt = window.performance.now();
        }
      }
      if (!sourceProduct || typeof sourceProduct !== 'object') {
        dataDiagnostics.skippedProducts += 1;
        continue;
      }
      const sourceTags = Array.isArray(sourceProduct.a)
        ? sourceProduct.a
        : Array.isArray(sourceProduct.tags)
          ? sourceProduct.tags
          : [];
      const sourceVariants = Array.isArray(sourceProduct.v)
        ? sourceProduct.v
        : Array.isArray(sourceProduct.variants)
          ? sourceProduct.variants
          : [];
      const tags = sourceTags.filter(Boolean).map(String);
      const variants = sourceVariants
        .filter((variant) => variant && typeof variant === 'object');
      const title = String(sourceProduct.t || sourceProduct.title || '').trim();
      const handle = String(sourceProduct.h || sourceProduct.handle || '').trim();
      const productId = firstDefined(sourceProduct.i, sourceProduct.id);
      if (!productId || !title || !handle || !variants.length) {
        dataDiagnostics.skippedProducts += 1;
        continue;
      }
      const product = {
        ...sourceProduct,
        t: title,
        h: handle,
        a: tags,
        v: variants,
        gl: String(
          sourceProduct.gl ||
            sourceProduct.gameLabel ||
            gameDescriptor.label ||
            sourceProduct.g ||
            sourceProduct.game ||
            '',
        ).trim(),
      };
      const fallbackRarity = chooseRarity(product);
      const rarityFacet = facetParts(
        readExplicitFacet(product, ['rarityFacet', 'normalizedRarity', 'rarity', 'rarityNormalized', 'fr']),
        fallbackRarity,
      );
      const fallbackSet = chooseSet(product, rarityFacet.label || fallbackRarity);
      const setFacet = facetParts(
        readExplicitFacet(product, ['setFacet', 'normalizedSet', 'set', 'setNormalized', 'fs']),
        fallbackSet,
      );
      const cardNumber = String(
        firstDefined(
          readExplicitFacet(product, ['cardNumber', 'normalizedCardNumber', 'number']),
          product.n,
          title.match(/\[([^\[\]]{1,40})\]\s*$/)?.[1]?.trim(),
        ) ?? '',
      ).trim();
      const searchableProductTags = tags.filter((tag) => {
        const key = normalizeKey(tag);
        if (key && (key === setFacet.key || key === rarityFacet.key)) return true;
        return !isVariantStructuralTag(tag);
      });
      const productTagSearch = normalizeSearch(searchableProductTags.join(' '));
      const titleSearch = normalizeSearch(title);
      const titleSeparator = title.indexOf(' - ');
      const cardName = (titleSeparator >= 0 ? title.slice(0, titleSeparator) : title).trim();
      const cardNameSearch = normalizeSearch(
        cardName,
      );
      const setSearch = normalizeSearch(setFacet.label);
      const raritySearch = normalizeSearch(rarityFacet.label);

      for (const variant of variants) {
        workUnits += 1;
        if (workUnits >= 32) {
          workUnits = 0;
          if (window.performance.now() - sliceStartedAt >= 12) {
            await yieldToBrowser();
            sliceStartedAt = window.performance.now();
          }
        }
        const variantId = firstDefined(variant.i, variant.id);
        const editionValue = String(firstDefined(variant.e, variant.edition, variant.release, '') || '');
        const priceSource = firstDefined(variant.price, variant.p);
        const price = amountValue(priceSource);
        const priceObject = asObject(priceSource);
        const priceCurrency = String(
          firstDefined(
            readExplicitFacet(variant, ['priceCurrency', 'currency', 'currencyCode']),
            priceObject?.currencyCode,
            priceObject?.currency,
            readExplicitFacet(product, ['priceCurrency', 'currency', 'currencyCode']),
            shopCurrency,
          ),
        ).toUpperCase();
        if (!variantId || price === null) {
          dataDiagnostics.skippedVariants += 1;
          continue;
        }
        if (priceCurrency !== shopCurrency) {
          dataDiagnostics.currencyMismatches += 1;
          dataDiagnostics.skippedVariants += 1;
          continue;
        }

        const explicitGrade = readExplicitFacet(variant, ['gradeLabel', 'normalizedGrade', 'grade']);
        let grade = String(firstDefined(asObject(explicitGrade)?.label, explicitGrade, '') || '').trim();
        const explicitGrader = facetParts(
          readExplicitFacet(variant, ['graderFacet', 'normalizedGrader', 'grader']),
        );
        const explicitScore = String(
          firstDefined(readExplicitFacet(variant, ['gradeScore', 'score']), '') || '',
        ).replace(',', '.');
        const explicitGraded = explicitBoolean(variant, ['isGraded', 'graded']);
        if (!grade && (explicitGrader.label || explicitScore)) {
          grade = `${explicitGrader.label || 'GRADED'} ${explicitScore}`.trim();
        }
        if (!grade && explicitGraded !== false) grade = chooseGrade(editionValue, tags, title);
        if (!grade && explicitGraded === true) grade = 'GRADED';
        const gradeMatch = grade.match(/^([A-Z]+)(?:\s+(\d+(?:\.\d+)?))?$/i);
        const grader =
          explicitGrader.label || (gradeMatch && grade.toUpperCase() !== 'GRADED' ? gradeMatch[1].toUpperCase() : '');
        const graderKey = explicitGrader.key || normalizeKey(grader);
        const gradeScore = explicitScore || gradeMatch?.[2] || '';

        const fallbackLanguage = canonicalLanguage(chooseLanguage(variant, tags));
        const languageFacet = facetParts(
          readExplicitFacet(variant, [
            'languageFacet',
            'normalizedLanguage',
            'language',
            'languageNormalized',
          ]),
          fallbackLanguage,
        );
        const fallbackCondition = canonicalCondition(chooseCondition(variant, tags));
        const rawConditionFacet = facetParts(
          readExplicitFacet(variant, [
            'conditionFacet',
            'normalizedCondition',
            'condition',
            'conditionNormalized',
          ]),
          fallbackCondition,
        );
        const condition = canonicalCondition(rawConditionFacet.label);
        const conditionKey = normalizeKey(condition);
        const explicitFinishFacet = readExplicitFacet(variant, [
          'finishFacet',
          'normalizedFinish',
          'finish',
        ]);
        const explicitEditionFacet = readExplicitFacet(variant, [
          'editionGroupFacet',
          'normalizedEditionGroup',
          'editionGroup',
          'releaseGroup',
        ]);
        const canUseSingleVariantTags = variants.length === 1 && editionValue.trim() === '';
        const fallbackFinish = chooseFinish(
          editionValue,
          canUseSingleVariantTags && explicitFinishFacet === undefined ? tags : [],
        );
        const finish = normalizedFinish(explicitFinishFacet, fallbackFinish);
        const fallbackEdition = chooseEditionGroup(
          editionValue,
          canUseSingleVariantTags && explicitEditionFacet === undefined ? tags : [],
        );
        const editionGroup = normalizedEditionGroup(explicitEditionFacet, fallbackEdition);
        const quantityRaw = firstDefined(
          readExplicitFacet(variant, ['inventoryQuantity', 'quantity', 'stock']),
          variant.q,
        );
        const quantity = Number(quantityRaw);
        const quantityKnown = Number.isFinite(quantity);
        const explicitAvailable = explicitBoolean(variant, [
          'orderable',
          'availableForSale',
          'available',
        ]);
        const available =
          explicitAvailable !== undefined
            ? explicitAvailable
            : typeof variant.s === 'boolean'
              ? variant.s
              : quantityKnown && quantity > 0;
        const language = languageFacet.label;
        const editionBadge = String(
          firstDefined(
            readExplicitFacet(variant, ['editionLabel', 'releaseLabel', 'edition']),
            chooseEditionBadge(editionValue),
          ) ?? '',
        ).trim();
        const variantSearch = normalizeSearch(
          [
            language,
            condition,
            editionBadge,
            finish,
            finishLabels[finish],
            editionGroup,
            editionGroupLabels[editionGroup],
            grade,
            cardNumber,
          ].join(' '),
        );
        const search = normalizeSearch(
          [title, handle, product.gl, setFacet.label, rarityFacet.label, productTagSearch, variantSearch].join(
            ' ',
          ),
        );
        rows.push({
          productId,
          variantId,
          title,
          cardName,
          handle,
          game: String(gameDescriptor.slug || product.g || product.game || ''),
          gameLabel: product.gl,
          tags,
          updatedAt: String(product.u || product.updatedAt || ''),
          image: variant.m || variant.image || product.m || product.image,
          price,
          priceCurrency,
          quantity: quantityKnown ? quantity : 0,
          quantityKnown,
          available,
          language,
          languageKey: languageFacet.key,
          condition,
          conditionKey: grade || conditionKey === 'mint' ? 'graded-mint' : conditionKey,
          conditionGroup:
            grade || conditionKey === 'mint' ? T.conditionGradedMint : condition,
          edition: editionValue,
          editionBadge,
          editionGroup,
          finish,
          grade,
          grader,
          graderKey,
          gradeScore,
          grading: grade ? 'graded' : 'ungraded',
          rarity: rarityFacet.label,
          rarityKey: rarityFacet.key,
          set: setFacet.label,
          setKey: setFacet.key,
          cardNumber,
          cardNumberSearch: normalizeCardNumber(cardNumber),
          cardNameSearch,
          cardNameWordSearch: ` ${cardNameSearch} `,
          titleSearch,
          titleWordSearch: ` ${titleSearch} `,
          setSearch,
          raritySearch,
          tagSearch: productTagSearch,
          variantSearch,
          search,
        });
      }
    }
    return rows;
  };

  const languageVisuals = new Map([
    ['english', { icon: '🇬🇧', tone: 'language' }],
    ['japanese', { icon: '🇯🇵', tone: 'language' }],
    ['german', { icon: '🇩🇪', tone: 'language' }],
    ['french', { icon: '🇫🇷', tone: 'language' }],
    ['italian', { icon: '🇮🇹', tone: 'language' }],
    ['spanish', { icon: '🇪🇸', tone: 'language' }],
    ['portuguese', { icon: '🇵🇹', tone: 'language' }],
    ['korean', { icon: '🇰🇷', tone: 'language' }],
    ['chinese', { icon: '🇨🇳', tone: 'language' }],
    ['simplified-chinese', { icon: '🇨🇳', tone: 'language' }],
    ['traditional-chinese', { icon: '🇹🇼', tone: 'language' }],
    ['czech', { icon: '🇨🇿', tone: 'language' }],
    ['dutch', { icon: '🇳🇱', tone: 'language' }],
    ['russian', { icon: '🇷🇺', tone: 'language' }],
    ['indonesian', { icon: '🇮🇩', tone: 'language' }],
  ]);
  const conditionVisuals = new Map([
    ['graded-mint', { icon: '🟢', tone: 'mint' }],
    ['mint', { icon: '🟢', tone: 'mint' }],
    ['near-mint', { icon: '🟢', tone: 'near-mint' }],
    ['excellent', { icon: '🟡', tone: 'excellent' }],
    ['lightly-played', { icon: '🟠', tone: 'lightly-played' }],
    ['moderately-played', { icon: '🟠', tone: 'moderately-played' }],
    ['heavily-played', { icon: '🔴', tone: 'heavily-played' }],
    ['damaged', { icon: '🔴', tone: 'damaged' }],
  ]);
  const visualFacetMeta = (facet, value, label = '') => {
    const key = normalizeKey(value || label);
    if (facet === 'language') {
      return languageVisuals.get(key) || { icon: '🌐', tone: value ? 'language' : 'neutral' };
    }
    if (facet === 'condition') {
      return conditionVisuals.get(key) || { icon: '◉', tone: 'neutral' };
    }
    return null;
  };
  const decorateVisualOption = (option, facet, value, baseLabel) => {
    const meta = visualFacetMeta(facet, value, baseLabel);
    if (!meta) return baseLabel;
    option.dataset.visualIcon = meta.icon;
    option.dataset.visualTone = meta.tone;
    return `${meta.icon} ${baseLabel}`;
  };
  const syncVisualFacetState = (select, facet) => {
    const row = select?.closest('[data-filter-row]');
    if (!row) return;
    const selected = select.selectedOptions[0];
    const meta = visualFacetMeta(facet, select.value, selected?.dataset.baseLabel || '');
    row.dataset.visualFacet = facet;
    row.dataset.visualTone = selected?.dataset.visualTone || meta?.tone || 'neutral';
    row.classList.toggle('has-value', Boolean(select.value));
  };

  const fillSelect = (
    select,
    values,
    allLabel,
    formatOption = (value) => value,
    visualFacet = '',
  ) => {
    if (!select) return;
    const current = select.value;
    const currentLabel = select.selectedOptions[0]?.dataset.baseLabel || select.selectedOptions[0]?.textContent;
    select.innerHTML = '';
    const allOption = document.createElement('option');
    allOption.value = '';
    allOption.dataset.baseLabel = allLabel;
    allOption.textContent = visualFacet
      ? decorateVisualOption(allOption, visualFacet, '', allLabel)
      : allLabel;
    select.appendChild(allOption);
    for (const entry of values) {
      const value = typeof entry === 'object' ? entry.key : entry;
      const label = typeof entry === 'object' ? entry.label : formatOption(value);
      if (!value) continue;
      const option = document.createElement('option');
      option.value = value;
      option.dataset.baseLabel = label;
      option.textContent = visualFacet
        ? decorateVisualOption(option, visualFacet, value, label)
        : label;
      select.appendChild(option);
    }
    if (current && ![...select.options].some((option) => option.value === current)) {
      const orphan = document.createElement('option');
      const orphanLabel = currentLabel || current;
      orphan.value = current;
      orphan.dataset.baseLabel = orphanLabel;
      orphan.dataset.orphan = 'true';
      orphan.textContent = visualFacet
        ? decorateVisualOption(orphan, visualFacet, current, orphanLabel)
        : orphanLabel;
      select.appendChild(orphan);
    }
    if ([...select.options].some((option) => option.value === current)) select.value = current;
    if (visualFacet) syncVisualFacetState(select, visualFacet);
  };

  const facetChoices = (source, key, labelKey = key) => {
    const labels = new Map();
    for (const item of source) {
      if (item[key] && !labels.has(item[key])) labels.set(item[key], item[labelKey] || item[key]);
    }
    return [...labels].map(([facetKey, label]) => ({ key: facetKey, label }));
  };

  const setIconGames = new Set(['pokemon', 'magic']);
  const magicSetCodeAliases = new Map(
    Object.entries({
      '30c': '30a',
      babp: 'pmtg1',
      cfic: 'fic',
      conf: 'con',
      dbl: 'pmtg1',
      dftfp: 'dft',
      gdc: 'pmtg1',
      gdy: 'pmtg1',
      gw: 'pmtg1',
      jwar: 'war',
      ltrh: 'ltr',
      mys: 'mb1',
      oh: 'pmtg1',
      rel: 'pmtg1',
      rixp: 'rix',
      rmh3: 'mh3',
      sch: 'pmtg1',
      sfdn: 'fdn',
      sldsm5: 'sld',
      slx: 'pmtg1',
      xdfc: 'drc',
      xlnp: 'xln',
      znl: 'mb1',
    }),
  );
  const magicSetNameAliases = new Map(
    Object.entries({
      alliances: 'all',
      chronicles: 'chr',
      'fallen-empires': 'fem',
      'fifth-edition': '5ed',
      'fourth-edition': '4ed',
      'friday-night-magic-promos': 'pfnm',
      homelands: 'hml',
      'ice-age': 'ice',
      legends: 'leg',
      mirage: 'mir',
      'mystery-booster-2-reprints-from-across-magics-history': 'mb2',
      'portal-second-age': 'p02',
      revised: '3ed',
      'secret-lair-commander-deck-everyones-invited': 'sld',
      stronghold: 'sth',
      tempest: 'tmp',
      visions: 'vis',
      weatherlight: 'wth',
    }),
  );
  const setCodeFromCardNumber = (value) =>
    String(value || '')
      .trim()
      .match(/^([a-z0-9]{2,12})[-\s]/i)?.[1]
      ?.toLowerCase() || '';
  const displaySetCode = (choice) => {
    const mappedCode = String(setSymbolMap.pokemon?.[choice.key]?.code || '');
    const rawCode = mappedCode || String(choice.code || '').replace(/^x(?=[a-z0-9]{2,}$)/i, '');
    if (rawCode) return rawCode.slice(0, 7).toUpperCase();
    return String(choice.label || '')
      .split(/\s+/)
      .filter(Boolean)
      .filter((part) => !/^(?:and|of|the)$/i.test(part))
      .slice(0, 4)
      .map((part) => part.charAt(0))
      .join('')
      .slice(0, 5)
      .toUpperCase() || 'PKM';
  };
  const magicSetCode = (choice) => {
    const nameAlias = magicSetNameAliases.get(choice.key);
    if (nameAlias) return nameAlias;
    const rawCode = String(choice.code || '').toLowerCase();
    const directAlias = magicSetCodeAliases.get(rawCode);
    if (directAlias) return directAlias;
    const label = String(choice.label || '');
    if (/\bextras?\b/i.test(label) && rawCode.startsWith('x')) return rawCode.slice(1);
    if (/\bpromos?\b/i.test(label) && rawCode.startsWith('p')) return rawCode.slice(1);
    if (/\btokens?\b/i.test(label) && rawCode.startsWith('t')) return rawCode.slice(1);
    if (/\bretro\b/i.test(label) && rawCode.startsWith('r')) return rawCode.slice(1);
    return /^[a-z0-9]{2,12}$/.test(rawCode) ? rawCode : 'pmtg1';
  };
  const setFacetChoices = (source) => {
    const choices = new Map();
    for (const item of source) {
      if (!item.setKey) continue;
      const game = String(item.game || '');
      const code = setCodeFromCardNumber(item.cardNumber);
      const current = choices.get(item.setKey);
      if (!current) {
        choices.set(item.setKey, {
          key: item.setKey,
          label: item.set || item.setKey,
          game,
          codeCounts: new Map(code ? [[code, 1]] : []),
        });
      } else if (code) {
        current.codeCounts.set(code, (current.codeCounts.get(code) || 0) + 1);
      }
    }
    return [...choices.values()].map(({ codeCounts, ...choice }) => ({
      ...choice,
      code: [...codeCounts].sort((a, b) => b[1] - a[1])[0]?.[0] || '',
    }));
  };

  let setChoices = [];
  let fullSetChoices = [];
  let cardSetChoices = new Map();
  let setResultCounts = new Map();
  let allSetResultsCount = 0;
  let activeSetSuggestionIndex = -1;
  let visibleSetChoices = [];
  let setSuggestionValue = '';
  let setSuggestionNeedle = '';
  let setSuggestionTotalMatches = 0;
  let renderedSetSuggestionCount = 0;
  const SET_SUGGESTION_BATCH_SIZE = 80;
  const SET_SUGGESTION_SEARCH_BATCH_SIZE = 140;
  const setChoiceCountLabel = (label, key = '') =>
    T.filterOptionCount
      .replace('{label}', label)
      .replace(
        '{count}',
        (key ? setResultCounts.get(key) || 0 : allSetResultsCount).toLocaleString(numberLocale),
      );
  const updateRenderedSetSuggestionCounts = () => {
    for (const option of els.setOptions?.children || []) {
      const labelText = option.querySelector('.lc-index__set-label-text');
      if (!labelText) continue;
      const baseLabel = labelText.dataset.baseLabel || labelText.textContent;
      const visibleLabel = setChoiceCountLabel(baseLabel, option.dataset.setKey || '');
      const count = option.querySelector('.lc-index__set-count');
      if (count) count.textContent = setChoiceCountLabel('', option.dataset.setKey || '').trim();
      option.setAttribute('aria-label', visibleLabel);
    }
  };
  let keyruneRequested = false;
  const ensureKeyrune = () => {
    // Keyrune (Magic-setsymbolen) pas laden wanneer er echt een Magic-symbool getoond wordt.
    if (keyruneRequested) return;
    keyruneRequested = true;
    if (document.querySelector('link[href*="keyrune"]')) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/keyrune@3.19.0/css/keyrune.min.css';
    link.integrity = 'sha384-L/JOEzKpLnNKM+L1ah7ZPvwx+9xWmvlBnquDfTswzqu2FnnLt9i/BGodaScwbl17';
    link.crossOrigin = 'anonymous';
    document.head.append(link);
  };
  // Pas laden als een Magic-symbool echt in beeld komt (niet voor de verborgen set-lijst in de filters).
  const keyruneObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      ensureKeyrune();
      keyruneObserver.disconnect();
    }, { rootMargin: '300px 0px' })
    : null;
  const ensureKeyruneWhenVisible = (element) => {
    if (keyruneRequested) return;
    if (keyruneObserver) keyruneObserver.observe(element);
    else ensureKeyrune();
  };
  const createSetIcon = (choice, { allowCodeFallback = true } = {}) => {
    if (!choice?.key || !setIconGames.has(choice.game)) return null;
    const symbol = choice.game === 'pokemon' ? setSymbolMap.pokemon?.[choice.key] : null;
    if (choice.game === 'pokemon' && !symbol?.src && !allowCodeFallback) return null;
    const icon = document.createElement('span');
    icon.className = `lc-index__set-icon lc-index__set-icon--${choice.game}`;
    icon.setAttribute('aria-hidden', 'true');
    if (choice.game === 'magic') {
      ensureKeyruneWhenVisible(icon);
      const glyph = document.createElement('i');
      glyph.className = `ss ss-fw ss-${magicSetCode(choice)}`;
      icon.append(glyph);
    } else if (symbol?.src) {
      const image = document.createElement('img');
      image.src = symbol.src;
      image.alt = '';
      image.loading = 'lazy';
      image.decoding = 'async';
      image.width = 32;
      image.height = 32;
      image.referrerPolicy = 'no-referrer';
      image.addEventListener('error', () => {
        if (!allowCodeFallback) {
          icon.remove();
          return;
        }
        image.remove();
        icon.classList.add('lc-index__set-icon--code');
        icon.textContent = displaySetCode(choice);
      }, { once: true });
      icon.append(image);
    } else {
      icon.classList.add('lc-index__set-icon--code');
      icon.textContent = displaySetCode(choice);
    }
    return icon;
  };
  const syncSelectedSetIcon = () => {
    if (!els.setSelectedIcon) return;
    const choice = setChoices.find((entry) => entry.key === els.set.value);
    const icon = createSetIcon(choice);
    els.setSelectedIcon.replaceChildren(...(icon ? [icon] : []));
    els.setSelectedIcon.hidden = !icon;
    els.setSearch?.closest('.lc-index__set-control')?.classList.toggle('has-set-icon', Boolean(icon));
  };
  const setChoiceByValue = (value) => {
    const needle = normalizeSearch(value);
    if (!needle) return null;
    return (
      setChoices.find((choice) => normalizeSearch(choice.label) === needle) ||
      setChoices.find((choice) => normalizeSearch(choice.key) === needle) ||
      null
    );
  };

  const setHiddenSetValue = (choice) => {
    const allOption = document.createElement('option');
    allOption.value = '';
    allOption.textContent = T.allSets;
    allOption.dataset.baseLabel = T.allSets;
    els.set.innerHTML = '';
    els.set.append(allOption);
    if (choice) {
      const option = document.createElement('option');
      option.value = choice.key;
      option.textContent = choice.label;
      option.dataset.baseLabel = choice.label;
      els.set.append(option);
      els.set.value = choice.key;
    }
  };

  const syncSetSearchDisplay = () => {
    if (!els.setSearch) return;
    const choice = setChoices.find((entry) => entry.key === els.set.value);
    els.setSearch.value = choice?.label || '';
    syncSelectedSetIcon();
  };

  const closeSetSuggestions = () => {
    if (!els.setPopup) return;
    if (typeof els.setPopup.hidePopover === 'function' && els.setPopup.matches(':popover-open')) els.setPopup.hidePopover();
    els.setPopup.hidden = true;
    els.setSearch?.setAttribute('aria-expanded', 'false');
    els.setSearch?.removeAttribute('aria-activedescendant');
    activeSetSuggestionIndex = -1;
  };

  const positionSetSuggestions = () => {
    if (!els.setPopup || els.setPopup.hidden || !els.setSearch) return;
    const rect = els.setSearch.getBoundingClientRect();
    const viewport = window.visualViewport;
    const viewportLeft = viewport?.offsetLeft || 0;
    const viewportTop = viewport?.offsetTop || 0;
    const viewportWidth = viewport?.width || document.documentElement.clientWidth;
    const viewportHeight = viewport?.height || window.innerHeight;
    const margin = 12;
    const topEdge = viewportTop + margin;
    const bottomEdge = viewportTop + viewportHeight - margin;
    if (rect.bottom <= topEdge || rect.top >= bottomEdge || !els.setSearch.getClientRects().length) {
      closeSetSuggestions();
      return;
    }
    const below = bottomEdge - rect.bottom - 6;
    const above = rect.top - topEdge - 6;
    const openBelow = below >= 160 || below >= above;
    const maxHeight = Math.min(320, Math.max(0, openBelow ? below : above));
    if (maxHeight < 44) {
      closeSetSuggestions();
      return;
    }
    const width = Math.min(rect.width, Math.max(0, viewportWidth - margin * 2));
    const left = Math.max(viewportLeft + margin, Math.min(rect.left, viewportLeft + viewportWidth - margin - width));
    els.setPopup.style.width = `${width}px`;
    els.setPopup.style.left = `${left}px`;
    els.setPopup.style.maxHeight = `${maxHeight}px`;
    els.setPopup.style.top = `${openBelow ? rect.bottom + 6 : Math.max(topEdge, rect.top - 6 - els.setPopup.offsetHeight)}px`;
  };

  const setActiveSetSuggestion = (index, { scroll = true } = {}) => {
    const options = Array.from(els.setOptions?.children || []);
    activeSetSuggestionIndex = options.length ? Math.max(-1, Math.min(index, options.length - 1)) : -1;
    options.forEach((option, optionIndex) => {
      const active = optionIndex === activeSetSuggestionIndex;
      option.classList.toggle('is-active', active);
      option.setAttribute('aria-selected', String(activeSetSuggestionIndex >= 0 ? active : option.dataset.setKey === els.set.value));
    });
    const activeOption = options[activeSetSuggestionIndex];
    if (!activeOption) {
      els.setSearch?.removeAttribute('aria-activedescendant');
      return;
    }
    els.setSearch.setAttribute('aria-activedescendant', activeOption.id);
    if (scroll && !els.setPopup.hidden) {
      const optionRect = activeOption.getBoundingClientRect();
      const popupRect = els.setPopup.getBoundingClientRect();
      if (optionRect.top < popupRect.top + 6) els.setPopup.scrollTop -= popupRect.top + 6 - optionRect.top;
      else if (optionRect.bottom > popupRect.bottom - 6) els.setPopup.scrollTop += optionRect.bottom - popupRect.bottom + 6;
    }
  };

  const renderSetSuggestions = (value = '', { append = false, renderAll = false } = {}) => {
    if (!els.setOptions) return;
    const activeKey = visibleSetChoices[activeSetSuggestionIndex]?.key;
    const needle = normalizeSearch(value);
    const matches = needle
      ? setChoices.filter((choice) =>
          `${normalizeSearch(choice.label)} ${normalizeSearch(choice.key)}`.includes(needle),
        )
      : setChoices;
    const continuing = append && needle === setSuggestionNeedle;
    const initialLimit = needle ? SET_SUGGESTION_SEARCH_BATCH_SIZE : SET_SUGGESTION_BATCH_SIZE;
    renderedSetSuggestionCount = renderAll
      ? matches.length
      : Math.min(
          matches.length,
          continuing ? renderedSetSuggestionCount + SET_SUGGESTION_BATCH_SIZE : initialLimit,
        );
    setSuggestionValue = value;
    setSuggestionNeedle = needle;
    setSuggestionTotalMatches = matches.length;
    const limitedMatches = matches.slice(0, renderedSetSuggestionCount);
    const selectedMatch = matches.find((choice) => choice.key === els.set.value);
    if (selectedMatch && !limitedMatches.some((choice) => choice.key === selectedMatch.key)) {
      limitedMatches.unshift(selectedMatch);
    }
    visibleSetChoices = [{ key: '', label: T.allSets }, ...limitedMatches];
    const matchPositions = new Map(matches.map((choice, index) => [choice.key, index + 2]));
    const previousScrollTop = append && els.setPopup ? els.setPopup.scrollTop : 0;
    const fragment = document.createDocumentFragment();
    visibleSetChoices.forEach((choice, index) => {
      const option = document.createElement('div');
      option.id = `${els.setOptions.id}-${index}`;
      option.className = 'lc-index__set-option';
      option.dataset.setKey = choice.key;
      option.setAttribute('role', 'option');
      option.setAttribute('aria-selected', String(choice.key === els.set.value));
      option.setAttribute('aria-setsize', String(matches.length + 1));
      option.setAttribute('aria-posinset', String(choice.key ? matchPositions.get(choice.key) : 1));
      option.setAttribute('aria-label', setChoiceCountLabel(choice.label, choice.key));
      const label = document.createElement('span');
      label.className = 'lc-index__set-label';
      const icon = createSetIcon(choice);
      if (icon) label.append(icon);
      const labelText = document.createElement('span');
      labelText.className = 'lc-index__set-label-text';
      labelText.dataset.baseLabel = choice.label;
      labelText.textContent = choice.label;
      label.append(labelText);
      const count = document.createElement('span');
      count.className = 'lc-index__set-count';
      count.setAttribute('aria-hidden', 'true');
      count.textContent = setChoiceCountLabel('', choice.key).trim();
      const check = document.createElement('span');
      check.className = 'lc-index__set-check';
      check.setAttribute('aria-hidden', 'true');
      check.textContent = choice.key === els.set.value ? '✓' : '';
      option.append(label, count, check);
      fragment.append(option);
    });
    els.setOptions.replaceChildren(fragment);
    if (append && els.setPopup) els.setPopup.scrollTop = previousScrollTop;
    if (els.setEmpty) {
      els.setEmpty.hidden = matches.length > 0 || !needle;
      els.setEmpty.textContent = matches.length || !needle ? '' : T.emptyQuery.replace('{query}', value.trim());
    }
    const activeIndex = activeKey === undefined ? -1 : visibleSetChoices.findIndex((choice) => choice.key === activeKey);
    setActiveSetSuggestion(activeIndex, { scroll: false });
    positionSetSuggestions();
  };

  const loadMoreSetSuggestions = ({ renderAll = false } = {}) => {
    if (renderedSetSuggestionCount >= setSuggestionTotalMatches) return false;
    renderSetSuggestions(setSuggestionValue, { append: true, renderAll });
    return true;
  };

  const openSetSuggestions = () => {
    if (!els.setPopup || !els.setSearch) return;
    const current = setChoices.find((choice) => choice.key === els.set.value);
    const query = current && els.setSearch.value === current.label ? '' : els.setSearch.value;
    renderSetSuggestions(query);
    els.setPopup.hidden = false;
    if (typeof els.setPopup.showPopover === 'function') {
      if (!els.setPopup.matches(':popover-open')) els.setPopup.showPopover();
    } else if (els.setPopup.parentElement !== root) {
      root.append(els.setPopup);
    }
    els.setSearch.setAttribute('aria-expanded', 'true');
    positionSetSuggestions();
  };

  const fillSetPicker = (choices) => {
    const current = els.set.value;
    const pendingGameLoad = current && (remoteSearchEnabled || (state.game === 'all'
      ? !manifestGames.length || state.loadedGames.size + state.failedGames.size < manifestGames.length
      : !state.loadedGames.has(state.game) && !state.failedGames.has(state.game)));
    const orphanChoice = pendingGameLoad
      ? {
          key: current,
          label:
            els.set.selectedOptions[0]?.dataset.baseLabel ||
            els.setSearch?.value ||
            current,
        }
      : null;
    const currentChoice = choices.find((choice) => choice.key === current) || orphanChoice;
    setChoices = currentChoice && !choices.some((choice) => choice.key === currentChoice.key)
      ? [currentChoice, ...choices]
      : choices;
    setHiddenSetValue(currentChoice);
    syncSelectedSetIcon();
    if (els.setPopup && !els.setPopup.hidden) {
      renderSetSuggestions(els.setSearch?.value || currentChoice?.label || '');
    } else {
      visibleSetChoices = [];
      activeSetSuggestionIndex = -1;
      els.setOptions?.replaceChildren();
    }
    if (document.activeElement !== els.setSearch) syncSetSearchDisplay();
  };

  const currentGameItems = () =>
    state.game === 'all' ? state.all : state.all.filter((item) => item.game === state.game);

  const setFilterRowVisible = (key, visible) => {
    const row = els.filterRows.get(key);
    if (!row) return;
    const control = row.querySelector('input, select');
    const active = Boolean(control && String(control.value || '').trim());
    row.hidden = !(visible || active);
  };

  const updateConditionalFilterRows = (source = currentGameItems()) => {
    if (remoteSearchEnabled) {
      const count = (key) => state.remoteFacets[key]?.values?.length || 0;
      setFilterRowVisible('grading', count('grading') > 1);
      setFilterRowVisible('grader', els.grading.value === 'graded' && count('grader') > 1);
      setFilterRowVisible('grade-score', els.grading.value === 'graded' && count('gradeScore') > 0);
      setFilterRowVisible('min-stock', els.availability.value !== 'sold-out' && count('minStock') > 0);
      return;
    }
    const gradedRows = source.filter((item) => item.grade);
    const graders = [...new Set(gradedRows.map((item) => item.graderKey).filter(Boolean))];
    const gradeScores = [
      ...new Set(
        gradedRows
          .filter((item) => !els.grader.value || item.graderKey === els.grader.value)
          .map((item) => item.gradeScore)
          .filter(Boolean),
      ),
    ];
    const gradingAllowsDetails = els.grading.value === 'graded';
    setFilterRowVisible('grading', gradedRows.length > 0 && gradedRows.length < source.length);
    setFilterRowVisible('grader', gradingAllowsDetails && graders.length > 1);
    setFilterRowVisible('grade-score', gradingAllowsDetails && gradeScores.length > 0);
    setFilterRowVisible(
      'min-stock',
      els.availability.value !== 'sold-out' &&
        source.some((item) => item.available && item.quantityKnown && item.quantity >= 2),
    );
  };

  const refreshOptions = () => {
    if (remoteSearchEnabled) return refreshRemoteOptions();
    const source = currentGameItems();
    const sortChoices = (choices) =>
      choices.sort((a, b) => String(a.label).localeCompare(String(b.label), numberLocale));
    const sets = sortChoices(setFacetChoices(source));
    fullSetChoices = sets;
    cardSetChoices = new Map(sets.map((choice) => [`${choice.game}:${choice.key}`, choice]));
    const rarities = sortChoices(
      facetChoices(source, 'rarityKey', 'rarity').map((choice) => ({
        ...choice,
        label: localizedFacetLabel('rarity', choice.key, choice.label),
      })),
    );
    const languages = sortChoices(
      facetChoices(source, 'languageKey', 'language').map((choice) => ({
        ...choice,
        label: localizedFacetLabel('language', choice.key, choice.label),
      })),
    );
    const conditions = facetChoices(source, 'conditionKey', 'conditionGroup').sort(
      (a, b) => {
        const rank = (choice) =>
          choice.key === 'graded-mint'
            ? conditionRank.get('Mint')
            : conditionRank.get(choice.label) ?? Number.MAX_SAFE_INTEGER;
        return rank(a) - rank(b) || a.label.localeCompare(b.label, numberLocale);
      },
    ).map((choice) => ({
      ...choice,
      label: localizedFacetLabel('condition', choice.key, choice.label),
    }));
    const finishes = [...new Set(source.map((item) => item.finish).filter(Boolean))]
      .sort((a, b) => finishOrder.indexOf(a) - finishOrder.indexOf(b))
      .map((key) => ({ key, label: finishLabels[key] || key }));
    const editions = [...new Set(source.map((item) => item.editionGroup).filter(Boolean))]
      .sort((a, b) => editionGroupOrder.indexOf(a) - editionGroupOrder.indexOf(b))
      .map((key) => ({ key, label: editionGroupLabels[key] || key }));
    const gradedRows = source.filter((item) => item.grade);
    const graders = sortChoices(facetChoices(gradedRows, 'graderKey', 'grader'));

    fillSetPicker(sets);
    fillSelect(els.rarity, rarities, T.allRarities);
    fillSelect(els.language, languages, T.allLanguages, undefined, 'language');
    fillSelect(
      els.condition,
      conditions,
      T.allConditions,
      undefined,
      'condition',
    );
    fillSelect(els.finish, finishes, T.allFinishes);
    fillSelect(els.edition, editions, T.allEditions);
    fillSelect(els.grader, graders, T.allGraders);
    const gradeScores = [
      ...new Set(
        gradedRows
          .filter((item) => !els.grader.value || item.graderKey === els.grader.value)
          .map((item) => item.gradeScore)
          .filter(Boolean),
      ),
    ].sort((a, b) => Number(b) - Number(a));
    fillSelect(els.gradeScore, gradeScores, T.allGradeScores);
    const maxQuantity = source.reduce(
      (maximum, item) =>
        item.available && item.quantityKnown
          ? Math.max(maximum, Number(item.quantity) || 0)
          : maximum,
      0,
    );
    const stockThresholds = [2, 3, 4].filter((value) => value <= maxQuantity).map(String);
    fillSelect(
      els.minStock,
      stockThresholds,
      T.allStockAmounts,
      (value) => T.stockAtLeast.replace('{count}', value),
    );
    const availableCount = source.filter((item) => item.available).length;
    const soldOutCount = source.length - availableCount;
    const availableOption = els.availability.querySelector('option[value="available"]');
    const soldOutOption = els.availability.querySelector('option[value="sold-out"]');
    if (availableOption) availableOption.disabled = availableCount === 0 && els.availability.value !== 'available';
    if (soldOutOption) soldOutOption.disabled = soldOutCount === 0 && els.availability.value !== 'sold-out';

    setFilterRowVisible('set', sets.length > 1);
    setFilterRowVisible('rarity', rarities.length > 1);
    setFilterRowVisible('language', languages.length > 1);
    setFilterRowVisible('condition', conditions.length > 1);
    setFilterRowVisible('finish', finishes.length > 1);
    setFilterRowVisible('edition', editions.length > 1);
    setFilterRowVisible('card-number', source.some((item) => item.cardNumberSearch));
    updateConditionalFilterRows(source);
  };

  const showActiveGame = () => {
    gameButtons.forEach((button) => {
      const active = button.dataset.game === state.game;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  };

  const updateGameCounts = (items, showFilteredCounts) => {
    if (remoteSearchEnabled) {
      for (const button of gameButtons) {
        const key = button.dataset.game;
        const count = Number(showFilteredCounts ? state.remoteGameCounts[key] || 0 : manifestAvailableCounts.get(key) || 0);
        const known = state.remoteReady || !showFilteredCounts;
        const badge = gameCountElements.get(key);
        const label = button.dataset.gameLabel || key;
        if (badge) {
          badge.textContent = count.toLocaleString(numberLocale);
          badge.hidden = !known;
        }
        button.setAttribute('aria-label', known ? `${label}: ${count.toLocaleString(numberLocale)} ${count === 1 ? T.result : T.results}` : label);
      }
      return;
    }
    const counts = showFilteredCounts
      ? new Map([['all', items.length]])
      : new Map(manifestAvailableCounts);
    if (showFilteredCounts) {
      for (const item of items) counts.set(item.game, (counts.get(item.game) || 0) + 1);
    }

    gameButtons.forEach((button) => {
      const count = counts.get(button.dataset.game) || 0;
      const badge = gameCountElements.get(button.dataset.game);
      const label = button.dataset.gameLabel || button.dataset.game;
      const countIsKnown = showFilteredCounts
        ? button.dataset.game === 'all'
          ? state.loadedGames.size === manifestAvailableCounts.size - 1
          : state.loadedGames.has(button.dataset.game)
        : counts.has(button.dataset.game);
      if (badge) {
        badge.textContent = count.toLocaleString(numberLocale);
        badge.hidden = !countIsKnown;
      }
      button.setAttribute(
        'aria-label',
        countIsKnown
          ? `${label}: ${count.toLocaleString(numberLocale)} ${count === 1 ? T.result : T.results}`
          : label,
      );
      if (countIsKnown) {
        button.title = `${count.toLocaleString(numberLocale)} ${count === 1 ? T.result : T.results}`;
      } else {
        button.removeAttribute('title');
      }
    });
  };

  const money = new Intl.NumberFormat(numberLocale, {
    style: 'currency',
    currency: shopCurrency,
  });

  const productUrl = (item) => {
    const url = new URL(
      localeUrl(`products/${encodeURIComponent(item.handle)}`),
      window.location.origin,
    );
    url.searchParams.set('variant', String(item.variantId));
    const currentParameters = new URL(window.location.href).searchParams;
    for (const key of ['preview_theme_id', 'preview_script_debug', '_fd', 'pb', '_ab', '_sc']) {
      const value = currentParameters.get(key);
      if (value) url.searchParams.set(key, value);
    }
    return `${url.pathname}${url.search}${url.hash}`;
  };

  const sizedImageUrl = (url, width) =>
    url ? `${url}${url.includes('?') ? '&' : '?'}width=${width}` : '';

  const mobileFilters = window.matchMedia('(max-width: 1024px)');
  let filterReturnFocus = null;
  const drawerBackground = [
    root.querySelector('.lc-index__hero'),
    root.querySelector('.lc-index__games'),
    els.filterTrigger,
    root.querySelector('.lc-index__results'),
  ].filter(Boolean);
  const drawerInertState = new Map();
  const drawerOutsideElements = () => {
    const elements = new Set(drawerBackground);
    let branch = root;
    while (branch?.parentElement) {
      const parent = branch.parentElement;
      Array.from(parent.children).forEach((sibling) => {
        if (
          sibling !== branch &&
          sibling instanceof HTMLElement &&
          sibling !== els.filterPanel &&
          !sibling.contains(els.filterPanel)
        ) {
          elements.add(sibling);
        }
      });
      if (parent === document.body) break;
      branch = parent;
    }
    return [...elements];
  };
  const setDrawerBackgroundInert = (inert) => {
    if (inert) {
      drawerOutsideElements().forEach((element) => {
        if (!drawerInertState.has(element)) drawerInertState.set(element, element.inert);
        element.inert = true;
      });
      return;
    }
    drawerInertState.forEach((wasInert, element) => {
      if (element.isConnected) element.inert = wasInert;
    });
    drawerInertState.clear();
  };

  const updateFilterUi = () => {
    const advancedControls = [
      els.rarity,
      els.finish,
      els.edition,
      els.grading,
      els.grader,
      els.gradeScore,
      els.minStock,
    ];
    for (const control of advancedControls) {
      control?.closest('[data-filter-advanced]')?.classList.toggle(
        'is-active',
        Boolean(String(control.value || '').trim()),
      );
    }
    const advancedOpen = root.classList.contains('show-advanced');
    if (els.moreFilters) els.moreFilters.setAttribute('aria-expanded', String(advancedOpen));
    if (els.moreFiltersLabel) {
      els.moreFiltersLabel.textContent = advancedOpen ? T.lessFilters : T.moreFilters;
    }
    const activeCount = [
      els.set.value,
      els.rarity.value,
      els.language.value,
      els.condition.value,
      els.edition.value,
      els.cardNumber.value.trim(),
      els.finish.value,
      els.grading.value,
      els.grader.value,
      els.gradeScore.value,
      els.minStock.value,
      els.min.value,
      els.max.value,
      els.availability.value !== 'available' ? els.availability.value : '',
    ].filter(Boolean).length;
    if (els.filterCount) {
      els.filterCount.textContent = String(activeCount);
      els.filterCount.hidden = activeCount === 0;
    }
    const dockCount = root.querySelector('[data-index-dock-count]');
    if (dockCount) {
      dockCount.textContent = String(activeCount);
      dockCount.hidden = activeCount === 0;
    }
    if (els.filterApply) {
      els.filterApply.textContent = T.viewResults.replace(
        '{count}',
        (remoteSearchEnabled ? state.total : state.filtered.length).toLocaleString(numberLocale),
      );
    }
  };

  const syncFilterMode = () => {
    const mobile = mobileFilters.matches;
    const open = root.classList.contains('is-filters-open');
    if (mobile) {
      els.filterPanel.setAttribute('role', 'dialog');
      els.filterPanel.setAttribute('aria-modal', 'true');
      els.filterPanel.setAttribute('aria-hidden', String(!open));
      els.filterPanel.inert = !open;
    } else {
      root.classList.remove('is-filters-open');
      document.body.classList.remove('lc-index-filters-open');
      els.filterTrigger.setAttribute('aria-expanded', 'false');
      els.filterBackdrop.hidden = true;
      els.filterPanel.inert = false;
      els.filterPanel.removeAttribute('role');
      els.filterPanel.removeAttribute('aria-modal');
      els.filterPanel.removeAttribute('aria-hidden');
      setDrawerBackgroundInert(false);
    }
  };

  const openFilters = () => {
    if (!mobileFilters.matches) return;
    filterReturnFocus = document.activeElement;
    els.filterBackdrop.hidden = false;
    root.classList.add('is-filters-open');
    document.body.classList.add('lc-index-filters-open');
    els.filterTrigger.setAttribute('aria-expanded', 'true');
    els.filterPanel.inert = false;
    els.filterPanel.setAttribute('aria-hidden', 'false');
    setDrawerBackgroundInert(true);
    window.requestAnimationFrame(() =>
      root.querySelector('[data-index-filters-close]')?.focus(),
    );
  };

  const closeFilters = (restoreFocus = true) => {
    closeSetSuggestions();
    root.classList.remove('is-filters-open');
    document.body.classList.remove('lc-index-filters-open');
    els.filterTrigger.setAttribute('aria-expanded', 'false');
    els.filterBackdrop.hidden = true;
    if (mobileFilters.matches) {
      els.filterPanel.inert = true;
      els.filterPanel.setAttribute('aria-hidden', 'true');
    }
    setDrawerBackgroundInert(false);
    if (restoreFocus && filterReturnFocus instanceof HTMLElement) filterReturnFocus.focus();
    filterReturnFocus = null;
  };

  const trapFilterFocus = (event) => {
    if (
      event.key !== 'Tab' ||
      !mobileFilters.matches ||
      !root.classList.contains('is-filters-open')
    ) {
      return;
    }
    const focusable = Array.from(
      els.filterPanel.querySelectorAll(
        'button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
    ).filter((element) => !element.hidden && element.getClientRects().length);
    if (!focusable.length) {
      event.preventDefault();
      els.filterPanel.focus();
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  // Singles-ronde 25-09-2026: kaart in TCG-stijl. Conditie en taal als korte codes
  // (NM, EX, EN, JP …; volledige naam als tooltip en voor schermlezers), holo/foil als
  // lint op de afbeelding, zeldzaamheid met symbool, grading als slab-label.
  const conditionCodes = {
    mint: 'MT',
    'graded-mint': 'MT',
    'near-mint': 'NM',
    excellent: 'EX',
    // zelfde schaal als de conditie-uitleg op de productpagina's (Cardmarket): GD, LP, PL, PO
    'lightly-played': 'GD',
    'moderately-played': 'LP',
    'heavily-played': 'PL',
    damaged: 'PO',
  };
  const languageCodes = {
    english: 'EN',
    japanese: 'JP',
    german: 'DE',
    french: 'FR',
    italian: 'IT',
    spanish: 'ES',
    portuguese: 'PT',
    korean: 'KR',
    chinese: 'CN',
    'simplified-chinese': 'CN',
    'traditional-chinese': 'TW',
    czech: 'CZ',
    dutch: 'NL',
    russian: 'RU',
    indonesian: 'ID',
  };
  const foilFinishes = new Set(['foil-holo', 'reverse-holo', 'cold-foil', 'rainbow-foil', 'refractor']);
  const rarityTier = (item) => {
    const value = normalizeKey(item.rarityKey || item.rarity);
    if (!value) return 'common';
    if (/secret|starlight|ultimate|illustration|alternate|alt-art|hyper|platinum|manga|quarter-century|ghost|collector|enchanted|showcase|serialized|impact-signing|^(?:sec|sar|sir|scr|ur|sp)$/.test(value)) return 'secret';
    if (/ultra|super|double|triple|mythic|gold|shiny|amazing|radiant|(?:^|-)ace(?:-|$)|epic|legend|majestic|character|parallel|prism|vmax|vstar|holo-v|holo-ex|holo-gx|trainer-gallery|special-rare|feature|^(?:sr|rr|rrr|cr|lr|ssr|chr|spr)$/.test(value)) return 'ultra';
    if (/rare|holo|promo|hero|special|^(?:r|pr|rh|p)$/.test(value)) return 'rare';
    if (/uncommon|^(?:u|uc)$/.test(value)) return 'uncommon';
    return 'common';
  };
  const raritySymbols = { common: '●', uncommon: '◆', rare: '★', ultra: '★', secret: '✦' };
  const cartIcons = '<svg class="lc-index-card__add-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2.5 3.5h2.2l2.1 10.3a1.2 1.2 0 0 0 1.2 1h8.6a1.2 1.2 0 0 0 1.2-.9l1.7-7H6"/><path d="M12.5 7.2v4.6M10.2 9.5h4.6"/><circle cx="9" cy="19.3" r="1.4"/><circle cx="16.6" cy="19.3" r="1.4"/></svg><svg class="lc-index-card__added-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  const cardImageColumns = () => (window.matchMedia('(max-width: 820px)').matches ? 2
    : window.matchMedia('(max-width: 1280px)').matches ? 3 : 4);

  const cardMarkup = (item, absoluteIndex = 0) => {
    const languageLabel = localizedFacetLabel('language', item.languageKey, item.language);
    const conditionLabel = localizedFacetLabel('condition', item.condition, item.condition);
    const gameLabel = localizedFacetLabel('game', item.game, item.gameLabel);
    const conditionKey = normalizeKey(item.conditionKey || item.condition);
    const conditionCode = conditionCodes[conditionKey]
      || String(item.condition || '').split(/\s+/).filter(Boolean).map((part) => part.charAt(0)).join('').slice(0, 3).toUpperCase();
    const languageCode = languageCodes[normalizeKey(item.languageKey || item.language)]
      || String(item.language || '').slice(0, 2).toUpperCase();
    const editionGroup = normalizeKey(item.editionGroup);
    const editionLabel = editionGroup
      ? editionGroup === 'standard'
        ? ''
        : editionGroup === 'parallel' && /parallel/i.test(item.editionBadge || '')
          ? item.editionBadge
          : editionGroupLabels[editionGroup] || item.editionBadge || ''
      : /^(?:normal|unlimited|standard)$/i.test(String(item.editionBadge || '').trim()) ? '' : item.editionBadge || '';
    const finishKey = normalizeKey(item.finish);
    const isFoil = foilFinishes.has(finishKey);
    const foilLabel = isFoil ? finishLabels[finishKey] || item.finish : '';
    const tier = rarityTier(item);
    const shinyGames = ['pokemon', 'yugioh', 'one-piece', 'dragon-ball-super', 'digimon', 'weiss-schwarz', 'cardfight-vanguard', 'gundam', 'final-fantasy-tcg'];
    const isShiny = !isFoil && (/holo/.test(normalizeKey(item.rarityKey || item.rarity)) || tier === 'secret' || (tier === 'ultra' && shinyGames.includes(item.game)));
    const rarityLabel = item.rarity ? localizedFacetLabel('rarity', item.rarityKey || item.rarity, item.rarity) : '';
    const variantBadges = [
      item.condition && !item.grade
        ? `<span class="lc-index-card__badge lc-index-card__badge--condition lc-index-card__badge--condition-${conditionTone(item.condition)}" data-variant-badge="condition" title="${escapeMarkup(conditionLabel)}"><span class="lc-index-card__badge-code" aria-hidden="true">${escapeMarkup(conditionCode)}</span><span class="lc-index-card__badge-text">${escapeMarkup(conditionLabel)}</span></span>`
        : '',
      item.language
        ? `<span class="lc-index-card__badge lc-index-card__badge--language" data-variant-badge="language" title="${escapeMarkup(languageLabel)}"><span aria-hidden="true">${escapeMarkup(languageCode)}</span><span class="lc-index__visually-hidden">${escapeMarkup(languageLabel)}</span></span>`
        : '',
      editionLabel
        ? `<span class="lc-index-card__badge lc-index-card__badge--edition lc-index-card__badge--edition-${editionTone(item.editionBadge || editionLabel)}" data-variant-badge="edition">${escapeMarkup(editionLabel)}</span>`
        : '',
    ]
      .filter(Boolean)
      .join('');
    const imageBadges = [
      state.game === 'all'
        ? `<span class="lc-index-card__game">${escapeMarkup(gameLabel)}</span>`
        : '',
      item.grade ? `<span class="lc-index-card__graded">${escapeMarkup(item.grade)}</span>` : '',
      isFoil ? `<span class="lc-index-card__foil"><span aria-hidden="true">✦</span> ${escapeMarkup(foilLabel)}</span>` : '',
      item.available ? '' : `<span class="lc-index-card__soldout">${escapeMarkup(T.soldOut)}</span>`,
    ]
      .filter(Boolean)
      .join('');
    const linkLabel = [item.title, languageLabel, conditionLabel, item.grade || item.editionBadge]
      .filter(Boolean)
      .join(', ');
    const itemUrl = productUrl(item);
    const displayTitle = item.cardName || item.title;
    const cardDetails = [item.set || gameLabel, item.cardNumber]
      .filter(Boolean)
      .join(' · ');
    const stockText = item.available && item.quantityKnown && item.quantity > 0
      ? item.quantity === 1
        ? T.stockOne
        : T.stockMany.replace('{count}', item.quantity.toLocaleString(numberLocale))
      : '';
    const columns = cardImageColumns();
    const eagerImage = absoluteIndex < columns * 2;
    const highPriorityImage = absoluteIndex < columns;
    const buyAction = item.available
      ? `<form method="post" action="${localeUrl('cart/add')}">
          <input type="hidden" name="id" value="${escapeMarkup(item.variantId)}">
          <button type="submit" class="lc-index-card__add" aria-label="${escapeMarkup(T.addLabel.replace('{title}', linkLabel))}">${cartIcons}<span class="lc-index-card__add-label">${escapeMarkup(T.add)}</span></button>
        </form>`
      : `<a class="lc-index-card__view" href="${escapeMarkup(itemUrl)}" data-product-link data-product-id="${escapeMarkup(item.productId)}" data-variant-id="${escapeMarkup(item.variantId)}" aria-label="${escapeMarkup(`${T.soldOutLabel.replace('{title}', linkLabel)}. ${T.viewProductLabel.replace('{title}', linkLabel)}`)}">${escapeMarkup(T.viewCard)}</a>`;
    const image = item.image
      ? `<img src="${escapeMarkup(sizedImageUrl(item.image, 420))}" srcset="${[240, 360, 420].map((width) => `${escapeMarkup(sizedImageUrl(item.image, width))} ${width}w`).join(', ')}" sizes="(max-width: 820px) 46vw, (max-width: 1024px) 31vw, (max-width: 1280px) 22vw, 260px" alt="" loading="${eagerImage ? 'eager' : 'lazy'}"${highPriorityImage ? ' fetchpriority="high"' : ' decoding="async"'} width="420" height="588">`
      : '<span class="lc-index-card__noimage" aria-hidden="true"></span>';
    return `
      <article class="lc-index-card${isFoil ? ' is-foil' : ''}${isShiny ? ' is-shiny' : ''}${item.available ? '' : ' is-soldout'}${item.grade ? ' is-graded' : ''}" data-product-id="${escapeMarkup(item.productId)}" data-variant-id="${escapeMarkup(item.variantId)}" data-game="${escapeMarkup(item.game)}" data-rarity-tier="${tier}">
        <a class="lc-index-card__image" href="${escapeMarkup(itemUrl)}" data-product-link data-product-id="${escapeMarkup(item.productId)}" data-variant-id="${escapeMarkup(item.variantId)}" aria-label="${escapeMarkup(linkLabel)}" tabindex="-1">
          ${image}${imageBadges}
        </a>
        <div class="lc-index-card__content">
          <h3><a href="${escapeMarkup(itemUrl)}" data-product-link data-product-id="${escapeMarkup(item.productId)}" data-variant-id="${escapeMarkup(item.variantId)}" title="${escapeMarkup(item.title)}">${escapeMarkup(displayTitle)}</a></h3>
          <p class="lc-index-card__details"><span>${escapeMarkup(cardDetails)}</span></p>
          <p class="lc-index-card__rarity lc-index-card__rarity--${tier}">${rarityLabel ? `<span class="lc-index-card__rarity-symbol" aria-hidden="true">${raritySymbols[tier]}</span><span class="lc-index-card__rarity-text">${escapeMarkup(rarityLabel)}</span>` : ''}</p>
          <div class="lc-index-card__badges">${variantBadges}</div>
          <p class="lc-index-card__stock${item.available && item.quantityKnown && item.quantity === 1 ? ' is-last' : ''}">${escapeMarkup(stockText)}</p>
          <div class="lc-index-card__buy">
            <strong aria-label="${escapeMarkup(T.priceLabel.replace('{price}', money.format(item.price)))}">${money.format(item.price)}</strong>
            ${buyAction}
          </div>
        </div>
      </article>`;
  };

  const render = (append = false) => {
    const gamePending = remoteSearchEnabled ? state.remotePending && !state.remoteReady : state.game === 'all'
      ? state.loadedGames.size + state.failedGames.size < manifestGames.length
      : !state.loadedGames.has(state.game) && !state.failedGames.has(state.game);
    const gameFailed = state.game !== 'all' && state.failedGames.has(state.game);
    if (!state.filtered.length && (gamePending || gameFailed)) {
      if (gameFailed || !els.grid.querySelector('.lc-index-card--skeleton')) {
        els.grid.innerHTML = '';
        els.grid.hidden = true;
      }
      els.empty.hidden = true;
      els.loadMore.hidden = true;
      els.count.textContent = gameFailed ? T.variantsUnavailable : T.loadingIndex;
      els.count.setAttribute('aria-busy', String(!gameFailed));
      state.shown = 0;
      return;
    }
    const end = Math.min(state.shown + state.pageSize, state.filtered.length);
    const pageItems = state.filtered.slice(state.shown, end);
    const html = pageItems
      .map((item, index) => cardMarkup(item, state.shown + index))
      .join('');
    if (append) els.grid.insertAdjacentHTML('beforeend', html);
    else els.grid.innerHTML = html;
    pageItems.forEach((item, index) => {
      if (!item.setKey || !setIconGames.has(item.game)) return;
      const choice = cardSetChoices.get(`${item.game}:${item.setKey}`) || {
        key: item.setKey,
        label: item.set,
        game: item.game,
        code: setCodeFromCardNumber(item.cardNumber),
      };
      const icon = createSetIcon(choice, { allowCodeFallback: false });
      if (!icon) return;
      icon.classList.add('lc-index-card__set-icon');
      els.grid.children[(append ? state.shown : 0) + index]
        ?.querySelector('.lc-index-card__details')?.prepend(icon);
    });
    state.shown = end;
    els.count.textContent = T.variantsCount.replace(
      '{count}',
      (remoteSearchEnabled ? state.total : state.filtered.length).toLocaleString(numberLocale),
    );
    els.count.setAttribute('aria-busy', 'false');
    els.empty.hidden = state.filtered.length !== 0;
    els.grid.hidden = state.filtered.length === 0;
    if (els.emptyQuery) {
      const rawQuery = els.search.value.trim() || els.cardNumber.value.trim();
      els.emptyQuery.hidden = !rawQuery;
      els.emptyQuery.textContent = rawQuery
        ? T.emptyQuery.replace('{query}', rawQuery)
        : '';
    }
    const resultTotal = remoteSearchEnabled ? state.total : state.filtered.length;
    els.loadMore.hidden = state.shown >= resultTotal;
    if (!els.loadMore.hidden) {
      els.loadMore.textContent = T.loadMoreRemaining.replace(
        '{count}',
        (resultTotal - state.shown).toLocaleString(numberLocale),
      );
    }
  };

  const hydrateVisibleSetIcons = () => {
    for (let index = 0; index < state.shown; index += 1) {
      const item = state.filtered[index];
      const details = els.grid.children[index]?.querySelector('.lc-index-card__details');
      if (!item?.setKey || !details || details.querySelector('.lc-index-card__set-icon')) continue;
      const choice = cardSetChoices.get(`${item.game}:${item.setKey}`) || {
        key: item.setKey, label: item.set, game: item.game, code: setCodeFromCardNumber(item.cardNumber),
      };
      const icon = createSetIcon(choice, { allowCodeFallback: false });
      if (icon) {
        icon.classList.add('lc-index-card__set-icon');
        details.prepend(icon);
      }
    }
  };

  const readFilterState = () => {
    const query = normalizeSearch(els.search.value.trim());
    const minPrice = els.min.value === '' ? 0 : amountValue(els.min.value);
    const maxPrice = els.max.value === '' ? Number.POSITIVE_INFINITY : amountValue(els.max.value);
    const priceRangeValid =
      minPrice !== null && maxPrice !== null && Number(minPrice) <= Number(maxPrice);
    if (els.priceError) els.priceError.hidden = priceRangeValid;
    [els.min, els.max].forEach((input) => {
      input.setAttribute('aria-invalid', String(!priceRangeValid));
    });
    return {
      query,
      queryTokens: tokenize(query),
      compactQuery: compactKey(query),
      cardNumberQuery: normalizeCardNumber(els.cardNumber.value.trim()),
      set: els.set.value,
      rarity: els.rarity.value,
      language: els.language.value,
      condition: els.condition.value,
      finish: els.finish.value,
      edition: els.edition.value,
      grading: els.grading.value,
      grader: els.grader.value,
      gradeScore: els.gradeScore.value,
      availability: els.availability.value,
      minStock: Number(els.minStock.value || 0),
      minPrice: priceRangeValid ? Number(minPrice) : 0,
      maxPrice: priceRangeValid ? Number(maxPrice) : Number.POSITIVE_INFINITY,
      priceRangeValid,
    };
  };

  const itemMatchesFilters = (item, filters, skipFacet = '') => {
    const availabilityMatches =
      filters.availability === 'all' ||
      (filters.availability === 'sold-out' ? !item.available : item.available);
    const queryMatches =
      !filters.queryTokens.length ||
      (item.cardNumberSearch && item.cardNumberSearch.includes(filters.compactQuery)) ||
      filters.queryTokens.every((token) => item.search.includes(token));
    return (
      queryMatches &&
      (skipFacet === 'cardNumber' ||
        !filters.cardNumberQuery ||
        item.cardNumberSearch.includes(filters.cardNumberQuery)) &&
      (skipFacet === 'set' || !filters.set || item.setKey === filters.set) &&
      (skipFacet === 'rarity' || !filters.rarity || item.rarityKey === filters.rarity) &&
      (skipFacet === 'language' || !filters.language || item.languageKey === filters.language) &&
      (skipFacet === 'condition' || !filters.condition || item.conditionKey === filters.condition) &&
      (skipFacet === 'finish' || !filters.finish || item.finish === filters.finish) &&
      (skipFacet === 'edition' || !filters.edition || item.editionGroup === filters.edition) &&
      (skipFacet === 'grading' || !filters.grading || filters.grading === item.grading) &&
      (skipFacet === 'grader' || !filters.grader || item.graderKey === filters.grader) &&
      (skipFacet === 'gradeScore' || !filters.gradeScore || item.gradeScore === filters.gradeScore) &&
      (skipFacet === 'availability' || availabilityMatches) &&
      (skipFacet === 'minStock' ||
        !filters.minStock ||
        (item.quantityKnown && item.quantity >= filters.minStock)) &&
      item.price >= filters.minPrice &&
      item.price <= filters.maxPrice
    );
  };

  const gameSearchExamples = {
    all: ['Pikachu', 'Blue-Eyes', 'Island', 'Luffy'],
    pokemon: ['Pikachu', 'Charizard', 'Eevee', 'Mew'],
    magic: ['Island', 'Lightning Bolt', 'Counterspell', 'Sol Ring'],
    yugioh: ['Blue-Eyes', 'Dark Magician', 'Red-Eyes', 'Stardust'],
    'one-piece': ['Luffy', 'Zoro', 'Nami', 'Ace'],
    lorcana: ['Elsa', 'Stitch', 'Mickey', 'Rapunzel'],
    'dragon-ball-super': ['Goku', 'Vegeta', 'Gohan', 'Broly'],
    digimon: ['Agumon', 'Gabumon', 'Greymon', 'Omnimon'],
    'flesh-and-blood': ['Fate Foreseen', 'Sink Below', 'Pummel', 'Command and Conquer'],
    riftbound: ['Ahri', 'Jinx', 'Yasuo', 'Lux'],
    'cardfight-vanguard': ['Blaster', 'Overlord', 'Dragon', 'Knight'],
    'weiss-schwarz': ['Rem', 'Emilia', 'Asuna', 'Miku'],
    gundam: ['Gundam', 'Zaku', 'Amuro', 'Wing'],
    'final-fantasy-tcg': ['Cloud', 'Tifa', 'Lightning', 'Yuna'],
    medabots: ['Metabee', 'Rokusho'],
  };
  const searchShortcutContainers = [
    root.querySelector('.lc-index__popular'),
    root.querySelector('.lc-index__empty-popular'),
  ].filter(Boolean);
  const updateSearchShortcuts = (source, filters) => {
    if (remoteSearchEnabled) {
      for (const container of searchShortcutContainers) {
        const terms = (gameSearchExamples[state.game] || gameSearchExamples.all)
          .filter((term) => normalizeSearch(term) !== filters.query).slice(0, 4);
        const signature = terms.join('\u0000');
        if (container.dataset.shortcutSignature !== signature) {
          container.querySelectorAll('[data-search-term]').forEach((button) => button.remove());
          for (const term of terms) {
            const button = document.createElement('button');
            button.type = 'button';
            button.dataset.searchTerm = term;
            button.textContent = term;
            container.append(button);
          }
          container.dataset.shortcutSignature = signature;
        }
        container.hidden = !terms.length;
      }
      return;
    }
    const withoutText = { ...filters, query: '', queryTokens: [], compactQuery: '' };
    const eligible = source.filter((item) => itemMatchesFilters(item, withoutText));
    const terms = [];
    const seen = new Set([filters.query]);
    const addTerm = (term) => {
      const normalized = normalizeSearch(term);
      if (!normalized || seen.has(normalized) || term.length > 42) return;
      const candidate = { ...withoutText, query: normalized, queryTokens: tokenize(normalized), compactQuery: compactKey(normalized) };
      if (!eligible.some((item) => itemMatchesFilters(item, candidate))) return;
      seen.add(normalized);
      terms.push(term);
    };
    for (const term of gameSearchExamples[state.game] || []) addTerm(term);
    for (const item of eligible) {
      if (terms.length >= 4) break;
      addTerm(item.cardName || '');
    }
    for (const container of searchShortcutContainers) {
      const signature = terms.join('\u0000');
      if (container.dataset.shortcutSignature !== signature) {
        container.querySelectorAll('[data-search-term]').forEach((button) => button.remove());
        for (const term of terms.slice(0, 4)) {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.searchTerm = term;
          button.textContent = term;
          container.append(button);
        }
        container.dataset.shortcutSignature = signature;
      }
      container.hidden = terms.length === 0;
    }
  };

  const relevanceScore = (item, filters) => {
    let score = 0;
    if (filters.query) {
      if (item.cardNumberSearch && item.cardNumberSearch === filters.compactQuery) score += 2400;
      if (item.cardNameSearch === filters.query) score += 1400;
      else if (item.cardNameSearch.startsWith(filters.query)) score += 800;
      else if (item.cardNameSearch.includes(filters.query)) score += 480;
      else if (item.titleSearch === filters.query) score += 180;
      else if (item.titleSearch.startsWith(filters.query)) score += 90;
      else if (item.titleSearch.includes(filters.query)) score += 45;
      for (const token of filters.queryTokens) {
        if (item.cardNumberSearch === normalizeCardNumber(token)) score += 220;
        if (item.cardNameWordSearch.includes(` ${token} `)) score += 160;
        else if (item.cardNameSearch.includes(token)) score += 100;
        else if (item.titleSearch.includes(token)) score += 20;
        if (item.setSearch.includes(token)) score += 24;
        if (item.raritySearch.includes(token)) score += 14;
        if (item.variantSearch.includes(token)) score += 18;
        if (item.tagSearch.includes(token)) score += 4;
      }
    }
    if (filters.cardNumberQuery) {
      if (item.cardNumberSearch === filters.cardNumberQuery) score += 1000;
      else if (item.cardNumberSearch.startsWith(filters.cardNumberQuery)) score += 300;
    }
    return score;
  };

  const hasActiveFilters = (filters) =>
    Boolean(
      filters.query ||
        filters.cardNumberQuery ||
        filters.set ||
        filters.rarity ||
        filters.language ||
        filters.condition ||
        filters.finish ||
        filters.edition ||
        filters.grading ||
        filters.grader ||
        filters.gradeScore ||
        filters.availability !== 'available' ||
        filters.minStock ||
        els.min.value ||
        els.max.value,
    );

  const activeFilterKeys = (filters) =>
    [
      filters.query ? 'query' : '',
      filters.cardNumberQuery ? 'card-number' : '',
      filters.set ? 'set' : '',
      filters.rarity ? 'rarity' : '',
      filters.language ? 'language' : '',
      filters.condition ? 'condition' : '',
      filters.finish ? 'finish' : '',
      filters.edition ? 'edition' : '',
      filters.grading ? 'grading' : '',
      filters.grader ? 'grader' : '',
      filters.gradeScore ? 'grade-score' : '',
      filters.availability !== 'available' ? 'availability' : '',
      filters.minStock ? 'min-stock' : '',
      els.min.value || els.max.value ? 'price' : '',
    ].filter(Boolean);

  const facetCountSpecs = [
    { key: 'set', select: els.set, itemKey: 'setKey' },
    { key: 'rarity', select: els.rarity, itemKey: 'rarityKey' },
    { key: 'language', select: els.language, itemKey: 'languageKey' },
    { key: 'condition', select: els.condition, itemKey: 'conditionKey' },
    { key: 'finish', select: els.finish, itemKey: 'finish' },
    { key: 'edition', select: els.edition, itemKey: 'editionGroup' },
    { key: 'grading', select: els.grading, itemKey: 'grading' },
    { key: 'grader', select: els.grader, itemKey: 'graderKey' },
    { key: 'gradeScore', select: els.gradeScore, itemKey: 'gradeScore' },
    {
      key: 'availability',
      select: els.availability,
      itemValue: (item) => (item.available ? 'available' : 'sold-out'),
    },
  ];

  let facetCountGeneration = 0;
  const updateFacetCounts = async (filters, generation) => {
    const source = currentGameItems();
    const facetResults = [];
    let sliceStartedAt = window.performance.now();
    for (const spec of facetCountSpecs) {
      if (!spec.select) continue;
      const counts = new Map();
      let allCount = 0;
      for (let index = 0; index < source.length; index += 1) {
        if (index % 64 === 0) {
          if (generation !== facetCountGeneration) return;
          if (window.performance.now() - sliceStartedAt >= 10) {
            await yieldToBrowser();
            if (generation !== facetCountGeneration) return;
            sliceStartedAt = window.performance.now();
          }
        }
        const item = source[index];
        if (!itemMatchesFilters(item, filters, spec.key)) continue;
        allCount += 1;
        const value = spec.itemValue ? spec.itemValue(item) : item[spec.itemKey];
        if (value) counts.set(value, (counts.get(value) || 0) + 1);
      }
      facetResults.push({ spec, counts, allCount });
    }

    let minStockResult = null;
    if (els.minStock) {
      const optionValues = Array.from(els.minStock.options, (option) => option.value);
      const counts = new Map(optionValues.map((value) => [value, 0]));
      for (let index = 0; index < source.length; index += 1) {
        if (index % 64 === 0) {
          if (generation !== facetCountGeneration) return;
          if (window.performance.now() - sliceStartedAt >= 10) {
            await yieldToBrowser();
            if (generation !== facetCountGeneration) return;
            sliceStartedAt = window.performance.now();
          }
        }
        const item = source[index];
        if (!itemMatchesFilters(item, filters, 'minStock')) continue;
        for (const value of optionValues) {
          const threshold = Number(value || 0);
          if (!threshold || (item.quantityKnown && item.quantity >= threshold)) {
            counts.set(value, (counts.get(value) || 0) + 1);
          }
        }
      }
      minStockResult = counts;
    }

    if (generation !== facetCountGeneration) return;
    for (const { spec, counts, allCount } of facetResults) {
      if (spec.key === 'set') {
        setResultCounts = counts;
        allSetResultsCount = allCount;
        updateRenderedSetSuggestionCounts();
      }
      const visualFacet = spec.key === 'language' || spec.key === 'condition' ? spec.key : '';
      for (const option of spec.select.options) {
        const baseLabel =
          option.dataset.baseLabel || option.textContent.replace(/\s+\([\d.,]+\)$/, '');
        option.dataset.baseLabel = baseLabel;
        const isAllOption = !option.value || (spec.key === 'availability' && option.value === 'all');
        const count = isAllOption ? allCount : counts.get(option.value) || 0;
        const visibleLabel = visualFacet
          ? decorateVisualOption(option, visualFacet, option.value, baseLabel)
          : baseLabel;
        option.textContent = T.filterOptionCount
          .replace('{label}', visibleLabel)
          .replace('{count}', count.toLocaleString(numberLocale));
        option.disabled = count === 0 && option.value !== spec.select.value;
      }
      const outputKey = spec.key === 'gradeScore' ? 'grade-score' : spec.key;
      const output = root.querySelector(`[data-filter-facet-count="${outputKey}"]`);
      if (output) {
        const selectedCount = spec.select.value
          ? spec.key === 'availability' && spec.select.value === 'all'
            ? allCount
            : counts.get(spec.select.value) || 0
          : allCount;
        output.textContent = `(${selectedCount.toLocaleString(numberLocale)})`;
        output.hidden = false;
      }
      if (visualFacet) syncVisualFacetState(spec.select, visualFacet);
    }
    if (els.minStock && minStockResult) {
      let selectedStockCount = 0;
      for (const option of els.minStock.options) {
        const baseLabel =
          option.dataset.baseLabel || option.textContent.replace(/\s+\([\d.,]+\)$/, '');
        option.dataset.baseLabel = baseLabel;
        const count = minStockResult.get(option.value) || 0;
        option.textContent = T.filterOptionCount
          .replace('{label}', baseLabel)
          .replace('{count}', count.toLocaleString(numberLocale));
        option.disabled = count === 0 && option.value !== els.minStock.value;
        if (option.value === els.minStock.value) selectedStockCount = count;
      }
      const output = root.querySelector('[data-filter-facet-count="min-stock"]');
      if (output) {
        output.textContent = `(${selectedStockCount.toLocaleString(numberLocale)})`;
        output.hidden = false;
      }
    }
  };

  const filterLabel = (control, fallback) => {
    const label = control?.closest('label');
    const explicitElement = label?.querySelector('.lc-index__filter-label');
    const explicitLabel = explicitElement
      ? Array.from(explicitElement.childNodes)
          .filter((node) => node.nodeType === Node.TEXT_NODE)
          .map((node) => node.textContent.trim())
          .filter(Boolean)
          .join(' ')
      : '';
    const ownText = label
      ? Array.from(label.childNodes)
          .filter((node) => node.nodeType === Node.TEXT_NODE)
          .map((node) => node.textContent.trim())
          .filter(Boolean)
          .join(' ')
      : '';
    return explicitLabel || ownText || fallback;
  };

  const selectedOptionLabel = (select) =>
    select?.selectedOptions[0]?.dataset.baseLabel || select?.selectedOptions[0]?.textContent || '';

  const renderActiveFilterChips = (filters) => {
    if (!els.activeFilters || !els.activeFiltersList) return;
    const chips = [];
    const addSelect = (key, select, fallback) => {
      if (!select?.value) return;
      chips.push({ key, label: `${filterLabel(select, fallback)}: ${selectedOptionLabel(select)}` });
    };
    if (els.cardNumber.value.trim()) {
      chips.push({
        key: 'card-number',
        label: `${filterLabel(els.cardNumber, '#')}: ${els.cardNumber.value.trim()}`,
      });
    }
    addSelect('set', els.set, 'Set');
    addSelect('rarity', els.rarity, 'Rarity');
    addSelect('language', els.language, 'Language');
    addSelect('condition', els.condition, 'Condition');
    addSelect('finish', els.finish, 'Finish');
    addSelect('edition', els.edition, 'Edition');
    addSelect('grading', els.grading, 'Grading');
    addSelect('grader', els.grader, 'Grader');
    addSelect('grade-score', els.gradeScore, 'Grade');
    if (els.availability.value !== 'available') {
      addSelect('availability', els.availability, 'Availability');
    }
    addSelect('min-stock', els.minStock, 'Stock');
    if (els.min.value || els.max.value) {
      const lower = els.min.value ? money.format(Number(els.min.value)) : '–';
      const upper = els.max.value ? money.format(Number(els.max.value)) : '–';
      chips.push({ key: 'price', label: `${lower} – ${upper}` });
    }
    els.activeFiltersList.innerHTML = '';
    for (const chip of chips) {
      const item = document.createElement('span');
      item.setAttribute('role', 'listitem');
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.filterChip = chip.key;
      button.textContent = `${chip.label} ×`;
      button.setAttribute('aria-label', T.removeFilter.replace('{label}', chip.label));
      item.append(button);
      els.activeFiltersList.append(item);
    }
    els.activeFilters.hidden = chips.length === 0;
  };

  const collator = new Intl.Collator(numberLocale, { sensitivity: 'base', numeric: true });

  const apply = ({ persist = true, preserveShown = false, analyticsReason = '', historyMode = analyticsReason ? 'commit' : 'replace' } = {}) => {
    if (remoteSearchEnabled) {
      if (analyticsReason) {
        window.clearTimeout(applyTimer);
        cancelSavedViewRestore();
      }
      const filters = readFilterState();
      state.query = filters.query;
      if (els.clearSearch) els.clearSearch.hidden = !filters.query;
      updateSearchShortcuts([], filters);
      updateFilterUi();
      renderActiveFilterChips(filters);
      state.remoteReset = true;
      if (persist) persistView({ mode: historyMode });
      if (!filters.priceRangeValid) {
        invalidateRemoteRequest();
        setRemoteBusy(false);
        state.remoteReset = false;
        if (els.priceError) setIndexStatus(els.priceError.textContent.trim(), 'error');
        return;
      }
      void requestRemoteSearch({ analyticsReason });
      return;
    }
    if (analyticsReason) {
      window.clearTimeout(applyTimer);
      cancelSavedViewRestore();
    }
    const countGeneration = ++facetCountGeneration;
    const filters = readFilterState();
    state.query = filters.query;
    const previousShown = state.shown;
    const source = currentGameItems();
    state.filtered = source.filter((item) => itemMatchesFilters(item, filters));
    const contextualSetSource =
      filters.queryTokens.length || filters.cardNumberQuery
        ? filters.set
          ? source.filter((item) => itemMatchesFilters(item, filters, 'set'))
          : state.filtered
        : source;
    const setFacetSource = filters.set
      ? source.filter((item) => itemMatchesFilters(item, filters, 'set'))
      : state.filtered;
    const contextualSetKeys = new Set();
    const contextualSetCounts = new Map();
    for (const item of setFacetSource) {
      if (!item.setKey) continue;
      contextualSetCounts.set(item.setKey, (contextualSetCounts.get(item.setKey) || 0) + 1);
    }
    for (const item of contextualSetSource) {
      if (item.setKey) contextualSetKeys.add(item.setKey);
    }
    setResultCounts = contextualSetCounts;
    allSetResultsCount = setFacetSource.length;
    const contextualSetChoices = fullSetChoices.filter((choice) =>
      contextualSetKeys.has(choice.key),
    );
    const currentSetChoice = setChoices.find((choice) => choice.key === els.set.value);
    if (
      currentSetChoice &&
      !contextualSetChoices.some((choice) => choice.key === currentSetChoice.key)
    ) {
      contextualSetChoices.unshift(currentSetChoice);
    }
    fillSetPicker(contextualSetChoices);
    const showGameCounts = hasActiveFilters(filters);
    const matchesWithoutGame = showGameCounts
      ? state.game === 'all'
        ? state.filtered
        : state.all.filter((item) => itemMatchesFilters(item, filters))
      : [];
    updateGameCounts(matchesWithoutGame, showGameCounts);

    if (els.sort.value === 'price-asc') state.filtered.sort((a, b) => a.price - b.price);
    if (els.sort.value === 'price-desc') state.filtered.sort((a, b) => b.price - a.price);
    if (els.sort.value === 'title-asc')
      state.filtered.sort((a, b) => collator.compare(a.title || '', b.title || ''));
    if (els.sort.value === 'newest')
      state.filtered.sort(
        (a, b) =>
          String(b.updatedAt || '').localeCompare(String(a.updatedAt || '')) ||
          collator.compare(a.title || '', b.title || ''),
      );
    if (els.sort.value === 'relevant' && (filters.queryTokens.length || filters.cardNumberQuery)) {
      state.filtered.forEach((item) => {
        item.relevance = relevanceScore(item, filters);
      });
      state.filtered.sort(
        (a, b) =>
          b.relevance - a.relevance ||
          collator.compare(a.title || '', b.title || ''),
      );
    }

    state.shown = 0;
    render();
    if (preserveShown) {
      const target = Math.min(Math.max(state.pageSize, previousShown), state.filtered.length);
      while (state.shown < target) render(true);
    }
    if (els.clearSearch) els.clearSearch.hidden = !filters.query;
    updateSearchShortcuts(source, filters);
    updateFilterUi();
    void updateFacetCounts(filters, countGeneration).catch(() => {});
    renderActiveFilterChips(filters);
    if (persist) persistView({ mode: historyMode });
    if (analyticsReason) {
      const signature = [
        analyticsReason,
        state.game,
        filters.queryTokens.length,
        filters.query.length,
        state.filtered.length,
        activeFilterKeys(filters).join(','),
      ].join('|');
      const searchAction = ['query', 'query_submit', 'popular_search'].includes(analyticsReason);
      const analyticsName = searchAction ? 'search' : 'filters_applied';
      publishAnalyticsOnce(analyticsName, signature, {
        reason: analyticsReason,
        queryLength: filters.query.length,
        tokenCount: filters.queryTokens.length,
        resultCount: state.filtered.length,
        activeFilters: activeFilterKeys(filters),
      });
      if (state.filtered.length === 0 && (state.game === 'all'
        ? state.loadedGames.size + state.failedGames.size >= manifestGames.length
        : state.loadedGames.has(state.game))) {
        publishAnalyticsOnce('zero_results', signature, {
          reason: analyticsReason,
          queryLength: filters.query.length,
          tokenCount: filters.queryTokens.length,
          activeFilters: activeFilterKeys(filters),
        });
      }
    }
  };

  const clearFilters = ({ applyNow = true, refreshNow = applyNow } = {}) => {
    closeSetSuggestions();
    els.cardNumber.value = '';
    if (els.setSearch) els.setSearch.value = '';
    [
      els.set,
      els.rarity,
      els.language,
      els.condition,
      els.finish,
      els.edition,
      els.grading,
      els.grader,
      els.gradeScore,
      els.minStock,
    ].forEach(
      (select) => (select.value = ''),
    );
    els.min.value = '';
    els.max.value = '';
    els.availability.value = 'available';
    updateConditionalFilterRows();
    if (refreshNow) refreshOptions();
    if (applyNow) apply({ analyticsReason: 'clear_filters' });
  };

  const clearSearch = () => {
    els.search.value = '';
    notifySearchValueChange();
    if (!els.cardNumber.value.trim()) els.sort.value = 'newest';
    apply({ analyticsReason: 'clear_search' });
    els.search.focus();
  };

  const resetAll = () => {
    els.search.value = '';
    notifySearchValueChange();
    clearFilters({ applyNow: false });
    els.sort.value = 'newest';
    state.game = 'all';
    showActiveGame();
    refreshOptions();
    apply({ analyticsReason: 'reset_all' });
    if (!remoteSearchEnabled && state.loadedGames.size + state.failedGames.size < manifestGames.length) {
      void loadRemainingGames();
    }
  };

  let pendingSavedScrollY = null;
  let pendingSavedShown = null;
  let viewRestoreGeneration = 0;
  const cancelSavedViewRestore = () => {
    viewRestoreGeneration += 1;
    pendingSavedScrollY = null;
    pendingSavedShown = null;
  };

  const restoreSavedView = (view = savedView, { applyNow = true } = {}) => {
    if (!view) return false;
    const restoreSelect = (select, value) => {
      if (!select || !value) {
        if (select) select.value = '';
        return;
      }
      const options = Array.from(select.options);
      const exact = options.find((option) => option.value === value);
      const canonicalValue =
        select === els.condition && normalizeKey(value) === 'mint'
          ? 'graded-mint'
          : normalizeKey(value);
      const canonical = options.find((option) => option.value === canonicalValue);
      if (exact || canonical) {
        select.value = (exact || canonical).value;
        return;
      }
      const orphan = document.createElement('option');
      const keepOriginalValue = [
        els.availability,
        els.gradeScore,
        els.grading,
        els.minStock,
        els.sort,
      ].includes(select);
      orphan.value = keepOriginalValue ? value : canonicalValue || value;
      orphan.textContent = value;
      orphan.dataset.baseLabel = value;
      orphan.dataset.orphan = 'true';
      select.appendChild(orphan);
      select.value = orphan.value;
    };

    els.search.value = typeof view.search === 'string' ? view.search : '';
    notifySearchValueChange();
    restoreSelect(els.set, view.set || '');
    restoreSelect(els.rarity, view.rarity || '');
    restoreSelect(els.language, view.language || '');
    restoreSelect(els.condition, view.condition || '');
    restoreSelect(els.edition, view.edition || '');
    els.cardNumber.value =
      typeof view.cardNumber === 'string' ? view.cardNumber : '';
    restoreSelect(els.finish, view.finish || '');
    restoreSelect(els.grading, view.grading || '');
    restoreSelect(els.grader, view.grader || '');
    restoreSelect(els.gradeScore, view.gradeScore || '');
    restoreSelect(
      els.availability,
      view.availability || (view.stock === false ? 'all' : 'available'),
    );
    restoreSelect(els.minStock, view.minStock || '');
    els.min.value = typeof view.min === 'string' ? view.min : '';
    els.max.value = typeof view.max === 'string' ? view.max : '';
    const restoredSort =
      view.sort || (view.search || view.cardNumber ? 'relevant' : 'newest');
    restoreSelect(
      els.sort,
      restoredSort === 'relevant' && !view.search && !view.cardNumber
        ? 'newest'
        : restoredSort,
    );
    syncSetSearchDisplay();
    updateConditionalFilterRows();

    if (applyNow && !remoteSearchEnabled) apply({ persist: false });
    const requestedShown = Math.max(state.pageSize, Number(view.shown) || state.pageSize);
    pendingSavedShown = requestedShown;
    const targetShown = Math.min(requestedShown, state.filtered.length);
    if (!remoteSearchEnabled) while (state.shown < targetShown) render(true);

    pendingSavedScrollY = Math.max(0, Number(view.scrollY) || 0);
    if (applyNow && remoteSearchEnabled) apply({ persist: false });
    return true;
  };

  const finalizeSavedViewRestore = () => {
    if (pendingSavedScrollY === null) return;
    const ready = remoteSearchEnabled ? state.remoteReady && !state.remotePending : state.game === 'all'
      ? manifestGames.length > 0 && state.loadedGames.size + state.failedGames.size >= manifestGames.length
      : state.loadedGames.has(state.game) || state.failedGames.has(state.game);
    if (!ready) return;
    const requestedShown = Math.max(
      state.pageSize,
      Number(pendingSavedShown) || state.pageSize,
    );
    const targetShown = Math.min(requestedShown, state.filtered.length);
    while (state.shown < targetShown) render(true);

    const scrollY = pendingSavedScrollY;
    const generation = viewRestoreGeneration;
    pendingSavedScrollY = null;
    pendingSavedShown = null;
    window.requestAnimationFrame(() =>
      window.requestAnimationFrame(() => {
        if (generation !== viewRestoreGeneration) return;
        const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        window.scrollTo({ top: Math.min(scrollY, maxScroll), left: 0 });
        persistView();
      }),
    );
  };

  const showCartMessage = (message, isError = false) => {
    let toast = root.querySelector('[data-cart-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'lc-index__toast';
      toast.dataset.cartToast = '';
      toast.setAttribute('role', 'status');
      root.appendChild(toast);
    }
    toast.textContent = message;
    toast.setAttribute('role', isError ? 'alert' : 'status');
    toast.classList.toggle('is-error', isError);
    toast.classList.add('is-visible');
    window.clearTimeout(showCartMessage.timer);
    showCartMessage.timer = window.setTimeout(() => toast.classList.remove('is-visible'), 2600);
  };

  const refreshCartCount = async () => {
    const response = await fetch(localeUrl('cart.js'), { credentials: 'same-origin' });
    if (!response.ok) return;
    const cart = await response.json();
    document
      .querySelectorAll(
        '[data-cart-count], .cart-count, .cart-count-bubble span[aria-hidden="true"], .header__icon--cart .countPill',
      )
      .forEach((element) => {
        element.textContent = String(cart.item_count);
        element.classList.toggle('hidden', cart.item_count === 0);
      });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  };

  root.addEventListener('submit', async (event) => {
    const form = event.target.closest('.lc-index-card__buy form');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const buttonLabel = button.querySelector('.lc-index-card__add-label') || button;
    const originalText = buttonLabel.textContent;
    const setButtonState = (text, buttonState = '') => {
      buttonLabel.textContent = text;
      if (buttonState) button.dataset.state = buttonState;
      else delete button.dataset.state;
    };
    button.disabled = true;
    setButtonState(T.adding, 'adding');

    const cartDrawer = document.querySelector('cart-drawer');
    const cartSections =
      typeof cartDrawer?.getSectionsToRender === 'function'
        ? cartDrawer.getSectionsToRender().map((section) => section.id)
        : ['cart-drawer', 'cart-icon-bubble'];
    let result;
    try {
      const response = await fetch(localeUrl('cart/add.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{ id: String(form.elements.id.value), quantity: 1 }],
          sections: cartSections,
          sections_url: window.location.pathname,
        }),
      });
      result = await response.json();
      if (!response.ok) throw new Error(result.description || T.addFailed);
    } catch (error) {
      button.disabled = false;
      setButtonState(originalText);
      showCartMessage(error.message || T.addFailed, true);
      publishAnalytics('add_to_cart_failed', { variantId: String(form.elements.id.value) });
      return;
    }

    setButtonState(T.added, 'added');
    showCartMessage(T.addedToCart);
    window.setTimeout(() => {
      button.disabled = false;
      setButtonState(originalText);
    }, 1400);
    const card = form.closest('[data-product-id][data-variant-id]');
    publishAnalytics('add_to_cart', {
      productId: String(card?.dataset.productId || ''),
      variantId: String(form.elements.id.value),
      quantity: 1,
      currency: shopCurrency,
    });

    try {
      if (
        typeof publish === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.cartUpdate
      ) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'lichcards-singles-index',
          productVariantId: form.elements.id.value,
          cartData: result,
        });
      }
      if (cartDrawer && typeof cartDrawer.renderContents === 'function' && result.sections) {
        await cartDrawer.renderContents(result);
      } else {
        await refreshCartCount();
      }
    } catch (_refreshError) {
      try {
        await refreshCartCount();
      } catch (_fallbackError) {
        // Het artikel is al toegevoegd; een drawerfout mag dit succes niet terugdraaien.
      }
    }
  });

  let manifestGames = [];
  let viewRestored = false;
  let loadedRefreshTimer = 0;
  const fallbackGameMap = new Map(normalizeGames(fallbackGames).map((game) => [game.slug, game]));
  const remoteText = ({
    nl: { loading: 'Zoeken…', error: 'Zoeken is tijdelijk niet gelukt. Probeer het opnieuw.', stale: 'De vorige resultaten blijven staan. Probeer opnieuw om je nieuwe zoekopdracht te laden.' },
    en: { loading: 'Searching…', error: 'Search is temporarily unavailable. Please try again.', stale: 'Your previous results are still shown. Retry to load your new search.' },
    de: { loading: 'Suche läuft…', error: 'Die Suche ist vorübergehend nicht verfügbar. Bitte erneut versuchen.', stale: 'Die bisherigen Ergebnisse bleiben sichtbar. Erneut versuchen, um die neue Suche zu laden.' },
    fr: { loading: 'Recherche en cours…', error: 'La recherche est temporairement indisponible. Réessayez.', stale: 'Les résultats précédents restent affichés. Réessayez pour charger votre nouvelle recherche.' },
    es: { loading: 'Buscando…', error: 'La búsqueda no está disponible temporalmente. Inténtalo de nuevo.', stale: 'Se siguen mostrando los resultados anteriores. Reintenta para cargar la nueva búsqueda.' },
    it: { loading: 'Ricerca in corso…', error: 'La ricerca non è momentaneamente disponibile. Riprova.', stale: 'Restano visibili i risultati precedenti. Riprova per caricare la nuova ricerca.' },
  })[interfaceLocale] || { loading: 'Searching…', error: 'Search is temporarily unavailable. Please try again.', stale: 'Your previous results are still shown. Retry to load your new search.' };
  let remoteRequestGeneration = 0;
  let remoteController = null;
  let autoLoadCount = 0;
  let remoteRetryAppend = false;

  const invalidateRemoteRequest = () => {
    remoteRequestGeneration += 1;
    remoteController?.abort();
    remoteController = null;
  };

  const remoteQueryUrl = () => {
    const query = buildSearchUrl();
    const url = new URL(remoteSearchEndpoint);
    for (const key of urlViewKeys) {
      const value = query.searchParams.get(key);
      if (value !== null && value !== '') url.searchParams.set(key, value);
    }
    url.searchParams.set('locale', interfaceLocale);
    url.searchParams.sort();
    return url;
  };

  const setRemoteBusy = (busy) => {
    state.remotePending = busy;
    root.classList.toggle('is-search-pending', busy);
    els.grid.setAttribute('aria-busy', String(busy));
    els.count.setAttribute('aria-busy', String(busy));
    els.loadMore.disabled = busy;
    if (busy) {
      setIndexStatus(remoteText.loading, 'loading');
      retryButton.hidden = true;
      els.empty.hidden = true;
      if (!state.remoteReady) {
        els.count.textContent = remoteText.loading;
        els.loadMore.hidden = true;
      }
    }
  };

  const refreshRemoteOptions = () => {
    if (!state.remoteReady) return;
    const facets = state.remoteFacets;
    const valuesFor = (key) => Array.isArray(facets[key]?.values) ? facets[key].values : [];
    const sortChoices = (values) => values.slice().sort((a, b) => String(a.label).localeCompare(String(b.label), numberLocale));
    const sets = sortChoices(valuesFor('set'));
    const pageSets = new Map(setFacetChoices(state.filtered).map((choice) => [`${choice.game}:${choice.key}`, choice]));
    for (const choice of sets) {
      if (!choice.code) choice.code = pageSets.get(`${choice.game}:${choice.key}`)?.code || '';
    }
    fullSetChoices = sets;
    cardSetChoices = new Map(sets.map((choice) => [`${choice.game}:${choice.key}`, choice]));
    setResultCounts = new Map(valuesFor('set').map((choice) => [choice.key, Number(choice.count) || 0]));
    allSetResultsCount = Number(facets.set?.total) || 0;
    fillSetPicker(sets);
    const configs = [
      ['rarity', els.rarity, T.allRarities],
      ['language', els.language, T.allLanguages, 'language'],
      ['condition', els.condition, T.allConditions, 'condition'],
      ['finish', els.finish, T.allFinishes],
      ['edition', els.edition, T.allEditions],
      ['grader', els.grader, T.allGraders],
      ['gradeScore', els.gradeScore, T.allGradeScores],
      ['minStock', els.minStock, T.allStockAmounts],
    ];
    for (const [key, select, allLabel, visualFacet = ''] of configs) {
      const values = valuesFor(key).map((entry) => ({
        ...entry,
        key: String(entry.key),
        label: key === 'condition' && entry.key === 'graded-mint' ? T.conditionGradedMint
          : key === 'finish' ? finishLabels[entry.key] || entry.label
          : key === 'edition' ? editionGroupLabels[entry.key] || entry.label
            : key === 'minStock' ? T.stockAtLeast.replace('{count}', entry.key)
              : ['rarity', 'language', 'condition'].includes(key) ? localizedFacetLabel(key, entry.key, entry.label)
                : entry.label,
      }));
      const sorted = key === 'gradeScore' ? values.sort((a, b) => Number(b.key) - Number(a.key))
        : key === 'minStock' ? values.sort((a, b) => Number(a.key) - Number(b.key))
          : key === 'finish' ? values.sort((a, b) => finishOrder.indexOf(a.key) - finishOrder.indexOf(b.key))
            : key === 'edition' ? values.sort((a, b) => editionGroupOrder.indexOf(a.key) - editionGroupOrder.indexOf(b.key))
              : key === 'condition' ? values.sort((a, b) => {
                const rank = (entry) => entry.key === 'graded-mint' ? conditionRank.get('Mint')
                  : conditionRank.get(valuesFor('condition').find((value) => value.key === entry.key)?.label) ?? Number.MAX_SAFE_INTEGER;
                return rank(a) - rank(b) || a.label.localeCompare(b.label, numberLocale);
              }) : sortChoices(values);
      fillSelect(select, sorted, allLabel, undefined, visualFacet);
    }
    for (const [key, select] of [['set', els.set], ...configs.map(([key, select]) => [key, select]), ['grading', els.grading], ['availability', els.availability]]) {
      if (!select) continue;
      const counts = new Map(valuesFor(key).map((entry) => [String(entry.key), Number(entry.count) || 0]));
      const total = Number(facets[key]?.total) || 0;
      const visualFacet = key === 'language' || key === 'condition' ? key : '';
      for (const option of select.options) {
        const base = option.dataset.baseLabel || option.textContent.replace(/\s+\([\d.,]+\)$/, '');
        option.dataset.baseLabel = base;
        const count = !option.value || key === 'availability' && option.value === 'all' ? total : counts.get(option.value) || 0;
        const label = visualFacet ? decorateVisualOption(option, visualFacet, option.value, base) : base;
        option.textContent = T.filterOptionCount.replace('{label}', label).replace('{count}', count.toLocaleString(numberLocale));
        option.disabled = count === 0 && option.value !== select.value;
      }
      if (visualFacet) syncVisualFacetState(select, visualFacet);
      const outputKey = key === 'gradeScore' ? 'grade-score' : key === 'minStock' ? 'min-stock' : key;
      const output = root.querySelector(`[data-filter-facet-count="${outputKey}"]`);
      if (output) {
        const selectedCount = !select.value || key === 'availability' && select.value === 'all' ? total : counts.get(select.value) || 0;
        output.textContent = `(${selectedCount.toLocaleString(numberLocale)})`;
        output.hidden = false;
      }
    }
    for (const key of ['set', 'rarity', 'language', 'condition', 'finish', 'edition']) {
      setFilterRowVisible(key, valuesFor(key).length > 1);
    }
    setFilterRowVisible('card-number', true);
    updateConditionalFilterRows();
    updateRenderedSetSuggestionCounts();
  };

  const validateRemotePayload = (payload, offset) => {
    if (!payload || Number(payload.version) !== 1 || !Array.isArray(payload.items) || !Array.isArray(payload.games)
      || !payload.facets || typeof payload.facets !== 'object' || !Number.isSafeInteger(payload.total) || payload.total < 0
      || Number(payload.offset) !== offset || payload.items.length > 48
      || payload.items.some((item) => !item || !/^\d+$/.test(String(item.variantId)) || !item.handle || !item.title || !Number.isFinite(item.price))) {
      throw new Error('Invalid search response');
    }
    if (offset < payload.total && payload.items.length === 0) throw new Error('Incomplete search response');
    return payload;
  };

  const takeSinglesPrefetch = (href) => {
    // theme.liquid start de eerste zoekopdracht al in de head; alleen bij exact dezelfde URL gebruiken.
    const prefetch = window.__lcSinglesPrefetch;
    if (!prefetch) return null;
    window.__lcSinglesPrefetch = null;
    return prefetch.href === href && prefetch.response ? prefetch.response : null;
  };
  const untilAborted = (promise, signal) => new Promise((resolve, reject) => {
    const abort = () => reject(new DOMException('Aborted', 'AbortError'));
    if (signal.aborted) {
      abort();
      return;
    }
    signal.addEventListener('abort', abort, { once: true });
    promise.then(resolve, reject).finally(() => signal.removeEventListener('abort', abort));
  });

  const fetchRemotePage = async (queryUrl, offset, signal, expectedGeneration = '') => {
    const url = new URL(queryUrl);
    url.searchParams.set('offset', String(offset));
    url.searchParams.set('limit', String(state.pageSize));
    if (expectedGeneration) url.searchParams.set('generation', expectedGeneration);
    for (let attempt = 0; attempt < 2; attempt += 1) {
      const controller = new AbortController();
      const abort = () => controller.abort();
      signal.addEventListener('abort', abort, { once: true });
      if (signal.aborted) controller.abort();
      const timeout = window.setTimeout(() => controller.abort(), 9000);
      try {
        let response = null;
        const early = attempt === 0 && offset === 0 && !expectedGeneration ? takeSinglesPrefetch(url.href) : null;
        if (early) {
          try {
            response = await untilAborted(early, controller.signal);
          } catch (earlyError) {
            if (controller.signal.aborted) throw earlyError;
            response = null;
          }
        }
        if (!response) {
          response = await fetch(url.href, { credentials: 'omit', headers: { Accept: 'application/json' }, signal: controller.signal });
        }
        if (!response.ok) {
          if (response.status === 409) {
            const error = new Error('Search index changed');
            error.code = 'GENERATION_CHANGED';
            throw error;
          }
          if (attempt === 0 && [429, 500, 502, 503, 504].includes(response.status) && !signal.aborted) continue;
          throw new Error('Search unavailable');
        }
        return validateRemotePayload(await response.json(), offset);
      } finally {
        window.clearTimeout(timeout);
        signal.removeEventListener('abort', abort);
      }
    }
    throw new Error('Search unavailable');
  };

  const requestRemoteSearch = async ({ append = false, keyboard = false, analyticsReason = '', generationRestarts = 0 } = {}) => {
    const queryUrl = remoteQueryUrl();
    const key = queryUrl.href;
    if (append && (state.remoteKey !== key || !state.remoteReady)) append = false;
    if (append && state.shown >= state.total) return;
    if (!append) autoLoadCount = 0;
    invalidateRemoteRequest();
    const generation = remoteRequestGeneration;
    const controller = new AbortController();
    remoteController = controller;
    const active = () => generation === remoteRequestGeneration && !controller.signal.aborted && remoteQueryUrl().href === key;
    const firstNewIndex = append ? state.shown : 0;
    let offset = append ? state.filtered.length : 0;
    const targetShown = Math.max(offset + state.pageSize, Number(pendingSavedShown) || 0);
    state.remoteReset = !append;
    remoteRetryAppend = append;
    setRemoteBusy(true);
    try {
      do {
        const payload = await fetchRemotePage(queryUrl, offset, controller.signal, offset ? state.remoteGeneration : '');
        if (!active()) return;
        if (state.game !== 'all' && !payload.games.some((game) => game.slug === state.game)) {
          state.game = 'all';
          showActiveGame();
          persistView();
          return requestRemoteSearch({ analyticsReason, generationRestarts });
        }
        if (offset && state.remoteGeneration && payload.generation !== state.remoteGeneration) {
          if (generationRestarts >= 1) throw new Error('Search index changed repeatedly');
          return requestRemoteSearch({ analyticsReason: 'index_refresh', generationRestarts: generationRestarts + 1 });
        }
        const items = payload.items;
        state.filtered = offset ? [...state.filtered, ...items] : items;
        state.all = state.filtered;
        state.total = payload.total;
        state.remoteReady = true;
        state.remoteKey = key;
        state.remoteGeneration = String(payload.generation || '');
        state.remoteFacets = payload.facets;
        state.remoteGameCounts = payload.gameCounts || {};
        manifestGames = payload.games;
        manifestAvailableCounts.clear();
        for (const game of manifestGames) manifestAvailableCounts.set(game.slug, Number(game.availableVariants) || 0);
        manifestTotalAvailable = Number(payload.totalAvailable) || 0;
        manifestAvailableCounts.set('all', manifestTotalAvailable);
        syncGameControls(manifestGames);
        showActiveGame();
        root.dataset.indexGeneration = state.remoteGeneration;
        if (els.eyebrow) els.eyebrow.textContent = T.inStockTotal.replace('{count}', manifestTotalAvailable.toLocaleString(numberLocale));
        refreshRemoteOptions();
        if (!offset) state.shown = 0;
        render(Boolean(offset));
        state.remoteReset = false;
        const filters = readFilterState();
        updateGameCounts([], hasActiveFilters(filters));
        updateFilterUi();
        renderActiveFilterChips(filters);
        offset = state.filtered.length;
      } while (active() && offset < state.total && offset < targetShown);
      if (!active()) return;
      setRemoteBusy(false);
      root.classList.remove('has-index-error');
      retryButton.hidden = true;
      setIndexStatus(T.searchReady, 'ready');
      if (append && state.shown > firstNewIndex) {
        if (keyboard) els.grid.children[firstNewIndex]?.querySelector('h3 a[data-product-link]')?.focus();
        if (els.loadMoreStatus) els.loadMoreStatus.textContent = T.resultsAdded.replace('{count}', (state.shown - firstNewIndex).toLocaleString(numberLocale));
      }
      if (analyticsReason) publishAnalytics(['query', 'query_submit', 'popular_search'].includes(analyticsReason) ? 'search' : 'filters_applied', {
        reason: analyticsReason, resultCount: state.total, queryLength: els.search.value.trim().length, activeFilters: activeFilterKeys(readFilterState()),
      });
      if (!state.total) publishAnalytics('zero_results', { resultCount: 0, queryLength: els.search.value.trim().length });
      finalizeSavedViewRestore();
      persistView();
    } catch (error) {
      if (!active()) return;
      if (error.code === 'GENERATION_CHANGED' && generationRestarts < 1) {
        return requestRemoteSearch({ analyticsReason: 'index_refresh', generationRestarts: generationRestarts + 1 });
      }
      remoteRetryAppend = offset > 0 && state.remoteKey === key;
      setRemoteBusy(false);
      root.classList.toggle('has-index-error', !state.remoteReady);
      setIndexStatus(state.remoteReady ? `${remoteText.error} ${remoteText.stale}` : remoteText.error, 'error');
      retryButton.hidden = false;
      retryButton.textContent = T.retry;
      if (!state.remoteReady) {
        els.count.textContent = T.variantsUnavailable;
        els.empty.hidden = true;
        els.loadMore.hidden = true;
      }
      publishAnalytics('search_failed', { errorType: error.name || 'Error' });
    } finally {
      if (generation === remoteRequestGeneration) remoteController = null;
    }
  };

  const retryButton = document.createElement('button');
  retryButton.type = 'button';
  retryButton.className = 'lc-index__retry';
  retryButton.dataset.indexRetry = '';
  retryButton.textContent = T.retry;
  retryButton.hidden = true;
  els.status.insertAdjacentElement('afterend', retryButton);

  const rebuildLoadedRows = () => {
    const seenVariants = new Set();
    state.all = manifestGames
      .flatMap((game) => state.gameRows.get(game.slug) || [])
      .filter((item) => {
        const key = String(item.variantId);
        if (seenVariants.has(key)) return false;
        seenVariants.add(key);
        return true;
      });
    if (els.eyebrow) {
      const availableTotal = manifestTotalAvailable || state.all.filter((item) => item.available).length;
      els.eyebrow.textContent = T.inStockTotal.replace(
        '{count}',
        availableTotal.toLocaleString(numberLocale),
      );
    }
  };

  const refreshLoadedIndex = ({ immediate = false } = {}) => {
    const refresh = () => {
      const previousUrl = buildSearchUrl().href;
      rebuildLoadedRows();
      refreshOptions();
      if (!viewRestored) {
        viewRestored = restoreSavedView();
        if (!viewRestored) apply({ persist: false });
      } else {
        apply({ persist: false, preserveShown: true });
      }
      const requestedGamesReady = state.game === 'all'
        ? state.loadedGames.size + state.failedGames.size >= manifestGames.length
        : state.loadedGames.has(state.game);
      const selectedFailure = state.failedGames.get(state.game);
      if (selectedFailure) {
        setIndexStatus(T.indexError.replace('{message}', selectedFailure.error.message), 'error');
      } else {
        setIndexStatus(requestedGamesReady ? T.searchReady : T.loadingIndex, requestedGamesReady ? 'ready' : 'loading');
      }
      // A newly loaded game can normalize an unavailable set choice. Keep this
      // entry's URL in sync without creating another user-navigation step.
      if (buildSearchUrl().href !== previousUrl) persistView();
      finalizeSavedViewRestore();
    };
    window.clearTimeout(loadedRefreshTimer);
    if (immediate) refresh();
    else loadedRefreshTimer = window.setTimeout(refresh, 100);
  };

  const loadGameRows = (game) => {
    if (state.loadedGames.has(game.slug)) return Promise.resolve(state.gameRows.get(game.slug) || []);
    if (state.loadingGames.has(game.slug)) return state.loadingGames.get(game.slug);
    const promise = (async () => {
      let primaryProducts = [];
      if (game.urls.length) {
        try {
          primaryProducts = await decodeGzip(game.urls, game.encoding);
        } catch (primaryError) {
          const fallback = fallbackGameMap.get(game.slug);
          const differentFallback =
            fallback && fallback.urls.join('|') !== game.urls.join('|') ? fallback : null;
          if (!differentFallback) throw primaryError;
          primaryProducts = await decodeGzip(differentFallback.urls, differentFallback.encoding);
        }
      }
      const supplementalSources = Array.isArray(game.supplementalSources)
        ? game.supplementalSources
        : [];
      const supplementalResults = await Promise.allSettled(
        supplementalSources.map((source) => loadSupplementSource(source)),
      );
      const supplementalProducts = supplementalResults
        .filter((result) => result.status === 'fulfilled')
        .flatMap((result) => result.value);
      supplementalResults.forEach((result, index) => {
        if (result.status !== 'rejected') return;
        publishAnalytics('index_supplement_failed', {
          game: game.slug,
          sourceKind: supplementalSources[index]?.kind || '',
          errorType: result.reason?.name || 'Error',
        });
      });
      const supplementFailure = supplementalResults.find((result) => result.status === 'rejected');
      if (!game.urls.length && supplementalResults.some((result) => result.status === 'rejected')) {
        throw supplementFailure.reason;
      }
      const rows = await flatten(
        [...productPayloadItems(primaryProducts), ...supplementalProducts],
        game,
      );
      const uniqueRows = [...new Map(rows.map((row) => [String(row.variantId), row])).values()];
      if (!uniqueRows.length) throw new Error(T.variantsUnavailable);
      state.gameRows.set(game.slug, uniqueRows);
      state.loadedGames.add(game.slug);
      state.failedGames.delete(game.slug);
      if (supplementFailure) {
        state.failedSupplements.set(game.slug, { game, error: supplementFailure.reason });
      } else {
        state.failedSupplements.delete(game.slug);
      }
      manifestAvailableCounts.set(
        game.slug,
        uniqueRows.filter((row) => row.available).length,
      );
      manifestTotalAvailable = manifestGames.reduce(
        (total, descriptor) => total + (manifestAvailableCounts.get(descriptor.slug) || 0),
        0,
      );
      manifestAvailableCounts.set('all', manifestTotalAvailable);
      setIndexStatus(T.gameLoaded.replace('{game}', game.label));
      publishAnalytics('index_game_loaded', { game: game.slug, variantCount: uniqueRows.length });
      return uniqueRows;
    })()
      .catch((error) => {
        state.failedGames.set(game.slug, { game, error });
        state.failedSupplements.delete(game.slug);
        publishAnalytics('index_game_failed', { game: game.slug, errorType: error.name || 'Error' });
        throw error;
      })
      .finally(() => state.loadingGames.delete(game.slug));
    state.loadingGames.set(game.slug, promise);
    return promise;
  };

  const updateRetryState = () => {
    const failedCount = new Set([
      ...state.failedGames.keys(),
      ...state.failedSupplements.keys(),
    ]).size;
    retryButton.hidden = failedCount === 0;
    retryButton.textContent = failedCount
      ? `${T.retry} (${failedCount.toLocaleString(numberLocale)})`
      : T.retry;
  };

  const retryFailedGames = async () => {
    if (remoteSearchEnabled) return requestRemoteSearch({ append: remoteRetryAppend });
    const failed = [...new Map(
      [...state.failedGames.values(), ...state.failedSupplements.values()]
        .map((entry) => [entry.game.slug, entry.game]),
    ).values()];
    failed.forEach((game) => {
      state.loadedGames.delete(game.slug);
      state.gameRows.delete(game.slug);
    });
    state.failedGames.clear();
    state.failedSupplements.clear();
    updateRetryState();
    publishAnalytics('index_retry', { gameCount: failed.length });
    const results = await Promise.allSettled(failed.map((game) => loadGameRows(game)));
    if (results.some((result) => result.status === 'fulfilled')) {
      root.classList.remove('has-index-error');
      refreshLoadedIndex({ immediate: true });
    }
    updateRetryState();
  };

  retryButton.addEventListener('click', retryFailedGames);

  const yieldToBrowser = () => {
    if (typeof window.scheduler?.yield === 'function') return window.scheduler.yield();
    return new Promise((resolve) => {
      window.setTimeout(resolve, 0);
    });
  };

  let allLoadGeneration = 0;
  const loadRemainingGames = async () => {
    if (remoteSearchEnabled) return;
    const generation = ++allLoadGeneration;
    const remaining = manifestGames.filter(
      (game) => !state.loadedGames.has(game.slug) && !state.failedGames.has(game.slug),
    ).sort(
      (a, b) =>
        (manifestAvailableCounts.get(a.slug) ?? Number.MAX_SAFE_INTEGER) -
        (manifestAvailableCounts.get(b.slug) ?? Number.MAX_SAFE_INTEGER),
    );
    for (const game of remaining) {
      if (state.game !== 'all' || generation !== allLoadGeneration) break;
      await yieldToBrowser();
      const [result] = await Promise.allSettled([loadGameRows(game)]);
      if (result.status === 'fulfilled') refreshLoadedIndex();
    }
    refreshLoadedIndex({ immediate: true });
    updateRetryState();
  };

  const loadActiveGame = () => {
    if (remoteSearchEnabled) return;
    const descriptor = manifestGames.find((game) => game.slug === state.game);
    if (descriptor && !state.loadedGames.has(descriptor.slug)) {
      setIndexStatus(T.loadingIndex);
      loadGameRows(descriptor)
        // Rebuild from the current controls, never from the selection that began
        // the request: Back/Forward can change games while this request is pending.
        .then(() => refreshLoadedIndex({ immediate: true }))
        .catch(() => refreshLoadedIndex({ immediate: true }))
        .finally(updateRetryState);
    } else if (state.game === 'all' && state.loadedGames.size < manifestGames.length) {
      setIndexStatus(T.loadingIndex);
      void loadRemainingGames();
    } else if (manifestGames.length) {
      refreshLoadedIndex({ immediate: true });
    }
  };

  const restoreHistoryView = () => {
    if (remoteSearchEnabled) invalidateRemoteRequest();
    window.clearTimeout(applyTimer);
    window.clearTimeout(loadedRefreshTimer);
    allLoadGeneration += 1;
    cancelSavedViewRestore();
    historyDraft = null;
    const view = readLocationView();
    state.game = !manifestGames.length || view.game === 'all' || manifestGames.some((game) => game.slug === view.game)
      ? view.game
      : 'all';
    closeSetSuggestions();
    closeFilters(false);
    showActiveGame();
    refreshOptions();
    viewRestored = restoreSavedView(view);
    loadActiveGame();
    finalizeSavedViewRestore();
  };

  const init = async () => {
    if (remoteSearchEnabled) {
      root.dataset.indexSource = 'server-search';
      void loadGameLogos();
      void loadSetSymbolMap().then(() => {
        syncSelectedSetIcon();
        hydrateVisibleSetIcons();
        if (els.setPopup && !els.setPopup.hidden) renderSetSuggestions(els.setSearch?.value || '');
      });
      updateSearchShortcuts([], readFilterState());
      await requestRemoteSearch();
      return;
    }
    try {
      setIndexStatus(T.loadingIndex);
      void loadGameLogos();
      const [manifest] = await Promise.all([loadCloudflareManifest(), loadSetSymbolMap()]);
      config.games = manifest.games;
      manifestGames = manifest.games;
      manifestAvailableCounts.clear();
      manifestTotalAvailable = manifestGames.reduce((total, game) => {
        const liveCount = Number(game.availableVariants ?? game.variantCount ?? game.variants ?? 0);
        const count = liveCount > 0 ? liveCount : staticAvailableCounts.get(game.slug) || 0;
        manifestAvailableCounts.set(game.slug, count);
        return total + count;
      }, 0);
      manifestAvailableCounts.set('all', manifestTotalAvailable);
      syncGameControls(manifestGames);
      if (state.game !== 'all' && !manifestGames.some((game) => game.slug === state.game)) {
        state.game = 'all';
      }
      showActiveGame();
      if (els.eyebrow) {
        els.eyebrow.textContent = T.inStockTotal.replace(
          '{count}',
          manifestTotalAvailable.toLocaleString(numberLocale),
        );
      }
      updateGameCounts([], false);

      const preferred =
        (state.game !== 'all' && manifestGames.find((game) => game.slug === state.game)) ||
        manifestGames.find((game) => game.slug === 'digimon') ||
        manifestGames[0];
      const ordered = [preferred, ...manifestGames.filter((game) => game !== preferred)].filter(Boolean);
      let firstLoaded = false;
      for (const game of ordered) {
        try {
          await loadGameRows(game);
          firstLoaded = true;
          refreshLoadedIndex({ immediate: true });
          break;
        } catch (_error) {
          // Probeer het volgende spel zodat één defect bestand de hele pagina niet blokkeert.
        }
      }
      if (!firstLoaded) throw new Error(T.variantsUnavailable);

      loadActiveGame();
      finalizeSavedViewRestore();
      updateRetryState();
      root.classList.remove('has-index-error');
      publishAnalytics('index_ready', {
        source: manifest.source,
        loadedGames: state.loadedGames.size,
        failedGames: state.failedGames.size,
        variantCount: state.all.length,
        skippedProducts: dataDiagnostics.skippedProducts,
        skippedVariants: dataDiagnostics.skippedVariants,
      });
    } catch (error) {
      updateRetryState();
      if (state.all.length) {
        refreshLoadedIndex({ immediate: true });
        finalizeSavedViewRestore();
        return;
      }
      setIndexStatus(T.indexError.replace('{message}', error.message), 'error');
      els.count.textContent = T.variantsUnavailable;
      els.count.setAttribute('aria-busy', 'false');
      root.classList.add('has-index-error');
    }
  };

  let applyTimer = 0;
  const scheduleApply = (analyticsReason, delay = 120) => {
    beginHistoryDraft();
    if (remoteSearchEnabled) invalidateRemoteRequest();
    window.clearTimeout(applyTimer);
    applyTimer = window.setTimeout(() => apply({ analyticsReason, historyMode: 'draft' }), delay);
  };

  els.search.addEventListener('input', () => {
    els.sort.value = els.search.value.trim() ? 'relevant' : els.cardNumber.value.trim() ? 'relevant' : 'newest';
    scheduleApply('query');
  });
  els.search.addEventListener('keydown', (event) => {
    if (event.isComposing) return;
    if (event.key === 'Enter') {
      event.preventDefault();
      window.clearTimeout(applyTimer);
      apply({ analyticsReason: 'query_submit' });
      root.querySelector('.lc-index__toolbar')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
    }
  });

  const commitSetSearch = ({ finalize = false } = {}) => {
    if (!els.setSearch) return;
    const typed = els.setSearch.value.trim();
    const selectedChoice = setChoices.find((entry) => entry.key === els.set.value);
    let choice = selectedChoice && normalizeSearch(selectedChoice.label) === normalizeSearch(typed)
      ? selectedChoice
      : setChoiceByValue(typed);
    if (!choice && finalize && typed) {
      const needle = normalizeSearch(typed);
      const matches = setChoices.filter((entry) =>
        `${normalizeSearch(entry.label)} ${normalizeSearch(entry.key)}`.includes(needle),
      );
      if (matches.length === 1) choice = matches[0];
    }
    const previous = els.set.value;
    if (choice) {
      setHiddenSetValue(choice);
      els.setSearch.value = choice.label;
    } else if (!typed || previous || finalize) {
      setHiddenSetValue(null);
      if (finalize && typed) els.setSearch.value = '';
    }
    if (els.set.value !== previous || (finalize && historyDraft)) {
      apply({ analyticsReason: 'filter', historyMode: finalize ? 'commit' : 'draft' });
    }
  };
  const chooseSetSuggestion = (key) => {
    const choice = key ? setChoices.find((entry) => entry.key === key) : null;
    if (key && !choice) return;
    const previous = els.set.value;
    setHiddenSetValue(choice);
    els.setSearch.value = choice?.label || '';
    closeSetSuggestions();
    if (els.set.value !== previous || historyDraft) apply({ analyticsReason: 'filter' });
  };
  els.setSearch?.addEventListener('focus', openSetSuggestions);
  els.setSearch?.addEventListener('click', () => {
    if (els.setPopup?.hidden) openSetSuggestions();
  });
  els.setSearch?.addEventListener('input', () => {
    beginHistoryDraft();
    activeSetSuggestionIndex = -1;
    const wasClosed = Boolean(els.setPopup?.hidden);
    if (wasClosed) openSetSuggestions();
    const exact = setChoiceByValue(els.setSearch.value);
    if (exact || !els.setSearch.value.trim() || els.set.value) commitSetSearch();
    if (!wasClosed) renderSetSuggestions(els.setSearch.value);
    if (els.setPopup) els.setPopup.scrollTop = 0;
  });
  els.setSearch?.addEventListener('change', () => commitSetSearch({ finalize: true }));
  els.setSearch?.addEventListener('blur', () => {
    closeSetSuggestions();
  });
  els.setSearch?.addEventListener('keydown', (event) => {
    if (event.isComposing) return;
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      if (els.setPopup?.hidden) openSetSuggestions();
      if (els.setPopup?.hidden) return;
      const direction = event.key === 'ArrowDown' ? 1 : -1;
      if (direction > 0 && activeSetSuggestionIndex === visibleSetChoices.length - 1) {
        loadMoreSetSuggestions();
      }
      const next = activeSetSuggestionIndex < 0
        ? (direction > 0 ? 0 : visibleSetChoices.length - 1)
        : activeSetSuggestionIndex + direction;
      setActiveSetSuggestion(next);
    } else if ((event.key === 'Home' || event.key === 'End') && activeSetSuggestionIndex >= 0 && !els.setPopup?.hidden && !event.shiftKey && !event.ctrlKey && !event.metaKey) {
      event.preventDefault();
      if (event.key === 'End') loadMoreSetSuggestions({ renderAll: true });
      setActiveSetSuggestion(event.key === 'Home' ? 0 : visibleSetChoices.length - 1);
    } else if (event.key === 'Enter') {
      event.preventDefault();
      const choice = !els.setPopup?.hidden && visibleSetChoices[activeSetSuggestionIndex];
      if (choice) chooseSetSuggestion(choice.key);
      else {
        commitSetSearch({ finalize: true });
        closeSetSuggestions();
      }
    } else if (event.key === 'Escape' && !els.setPopup?.hidden) {
      event.preventDefault();
      event.stopPropagation();
      closeSetSuggestions();
    } else if (event.key === 'Tab') {
      closeSetSuggestions();
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      setActiveSetSuggestion(-1, { scroll: false });
    }
  });
  els.setPopup?.addEventListener('pointerdown', (event) => {
    if (event.target.closest('[data-set-key]')) event.preventDefault();
  });
  els.setPopup?.addEventListener('click', (event) => {
    const option = event.target.closest('[data-set-key]');
    if (option) chooseSetSuggestion(option.dataset.setKey);
  });
  els.setPopup?.addEventListener('scroll', () => {
    const remaining = els.setPopup.scrollHeight - els.setPopup.scrollTop - els.setPopup.clientHeight;
    if (remaining <= Math.max(88, els.setPopup.clientHeight * 0.35)) loadMoreSetSuggestions();
  }, { passive: true });
  document.addEventListener('pointerdown', (event) => {
    if (event.target !== els.setSearch && !els.setPopup?.contains(event.target)) closeSetSuggestions();
  });
  document.addEventListener('scroll', (event) => {
    if (!els.setPopup?.contains(event.target)) positionSetSuggestions();
  }, true);
  window.addEventListener('resize', positionSetSuggestions);
  window.visualViewport?.addEventListener('resize', positionSetSuggestions);
  window.visualViewport?.addEventListener('scroll', positionSetSuggestions);

  els.clearSearch?.addEventListener('click', clearSearch);
  root.querySelectorAll('[data-index-clear-filters]').forEach((button) =>
    button.addEventListener('click', () => clearFilters()),
  );
  root.querySelectorAll('[data-index-reset-all]').forEach((button) =>
    button.addEventListener('click', resetAll),
  );
  els.moreFilters?.addEventListener('click', () => {
    root.classList.toggle('show-advanced');
    updateFilterUi();
  });
  let loadMoreAnnouncementFrame = 0;
  els.loadMore.addEventListener('click', (event) => {
    if (remoteSearchEnabled) {
      if (!state.remotePending) void requestRemoteSearch({ append: true, keyboard: event.detail === 0 });
      return;
    }
    const firstNewIndex = state.shown;
    render(true);
    const addedCount = state.shown - firstNewIndex;
    if (addedCount > 0) {
      if (event.detail === 0) {
        els.grid.children[firstNewIndex]?.querySelector('h3 a[data-product-link]')?.focus();
      }
      if (els.loadMoreStatus) {
        window.cancelAnimationFrame(loadMoreAnnouncementFrame);
        els.loadMoreStatus.textContent = '';
        loadMoreAnnouncementFrame = window.requestAnimationFrame(() => {
          els.loadMoreStatus.textContent = T.resultsAdded.replace(
            '{count}',
            addedCount.toLocaleString(numberLocale),
          );
        });
      }
    }
    persistView();
  });
  [els.set, els.rarity, els.language, els.condition, els.finish, els.edition, els.sort].forEach(
    (input) =>
      input.addEventListener('change', () => {
        if (input === els.language) syncVisualFacetState(input, 'language');
        if (input === els.condition) syncVisualFacetState(input, 'condition');
        apply({ analyticsReason: 'filter' });
      }),
  );
  els.cardNumber.addEventListener('input', () => {
    els.sort.value = els.cardNumber.value.trim() ? 'relevant' : els.search.value.trim() ? 'relevant' : 'newest';
    scheduleApply('filter');
  });
  [els.min, els.max].forEach((input) =>
    input.addEventListener('input', () => scheduleApply('filter')),
  );
  [els.cardNumber, els.min, els.max].forEach((input) => {
    input.addEventListener('change', () => apply({ analyticsReason: 'filter' }));
    input.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' || event.isComposing) return;
      event.preventDefault();
      apply({ analyticsReason: 'filter' });
    });
  });
  els.grading.addEventListener('change', () => {
    if (els.grading.value !== 'graded') {
      els.grader.value = '';
      els.gradeScore.value = '';
    }
    updateConditionalFilterRows();
    apply({ analyticsReason: 'filter' });
  });
  els.grader.addEventListener('change', () => {
    refreshOptions();
    apply({ analyticsReason: 'filter' });
  });
  els.gradeScore.addEventListener('change', () => apply({ analyticsReason: 'filter' }));
  els.availability.addEventListener('change', () => {
    if (els.availability.value !== 'available') els.minStock.value = '';
    updateConditionalFilterRows();
    apply({ analyticsReason: 'filter' });
  });
  els.minStock.addEventListener('change', () => {
    if (els.minStock.value) els.availability.value = 'available';
    updateConditionalFilterRows();
    apply({ analyticsReason: 'filter' });
  });
  gamesContainer?.addEventListener('click', (event) => {
    const button = event.target.closest('[data-game]');
    if (!button || button.disabled || button.hidden) return;
    state.game = button.dataset.game;
    if (state.game !== 'all') allLoadGeneration += 1;
    showActiveGame();
    refreshOptions();
    apply({ analyticsReason: 'game' });
    publishAnalytics('game_selected', { game: state.game });
    loadActiveGame();
  });
  root.querySelectorAll('[data-index-reset]:not([data-index-reset-all])').forEach((button) =>
    button.addEventListener('click', resetAll),
  );
  root.addEventListener('click', (event) => {
    const button = event.target.closest('[data-search-term]');
    if (!button || !root.contains(button)) return;
    window.clearTimeout(applyTimer);
    els.search.value = button.dataset.searchTerm;
    els.sort.value = 'relevant';
    notifySearchValueChange();
    els.search.focus();
    apply({ analyticsReason: 'popular_search' });
  });

  els.activeFiltersList?.addEventListener('click', (event) => {
    const button = event.target.closest('[data-filter-chip]');
    if (!button) return;
    const key = button.dataset.filterChip;
    const controls = {
      'card-number': els.cardNumber,
      condition: els.condition,
      edition: els.edition,
      finish: els.finish,
      grader: els.grader,
      grading: els.grading,
      'grade-score': els.gradeScore,
      language: els.language,
      'min-stock': els.minStock,
      rarity: els.rarity,
      set: els.set,
    };
    if (key === 'price') {
      els.min.value = '';
      els.max.value = '';
    } else if (key === 'availability') {
      els.availability.value = 'available';
    } else if (controls[key]) {
      controls[key].value = '';
      if (key === 'set' && els.setSearch) els.setSearch.value = '';
      if (key === 'grading') {
        els.grader.value = '';
        els.gradeScore.value = '';
      }
    }
    updateConditionalFilterRows();
    if (key === 'grader' || key === 'grading') refreshOptions();
    apply({ analyticsReason: 'chip_removed' });
  });

  const persistBeforeProductNavigation = (event) => {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    if (target?.closest('[data-product-link]')) {
      persistView({ mode: event.type === 'click' ? 'commit' : 'replace' });
    }
  };
  root.addEventListener('pointerdown', persistBeforeProductNavigation);
  root.addEventListener('click', persistBeforeProductNavigation);
  root.addEventListener('click', (event) => {
    const link = event.target.closest('[data-product-link]');
    if (!link) return;
    publishAnalytics('product_click', {
      productId: String(link.dataset.productId || link.closest('[data-product-id]')?.dataset.productId || ''),
      variantId: String(link.dataset.variantId || link.closest('[data-variant-id]')?.dataset.variantId || ''),
      position: Array.from(els.grid.querySelectorAll('.lc-index-card')).indexOf(
        link.closest('.lc-index-card'),
      ),
    });
  });
  window.addEventListener('pagehide', persistView);
  window.addEventListener('popstate', restoreHistoryView);

  els.filterTrigger.addEventListener('click', openFilters);
  els.filterBackdrop.addEventListener('click', () => closeFilters());
  root
    .querySelectorAll('[data-index-filters-close], [data-index-filters-apply]')
    .forEach((button) => button.addEventListener('click', () => closeFilters()));
  els.filterPanel.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeFilters();
      return;
    }
    trapFilterFocus(event);
  });
  const handleFilterModeChange = () => {
    const activeElement = document.activeElement;
    const focusWasInPanel =
      activeElement instanceof HTMLElement && els.filterPanel.contains(activeElement);
    const focusWasOnTrigger = activeElement === els.filterTrigger;
    closeFilters(false);
    syncFilterMode();
    if (!focusWasInPanel && !focusWasOnTrigger) return;
    window.requestAnimationFrame(() => {
      const desktopFilter = Array.from(
        els.filterPanel.querySelectorAll(
          'select:not([disabled]), input:not([disabled]), button:not([disabled])',
        ),
      ).find((element) => !element.hidden && element.getClientRects().length > 0);
      const target = mobileFilters.matches ? els.filterTrigger : desktopFilter || els.filterTrigger;
      if (target instanceof HTMLElement && !target.inert && target.getClientRects().length > 0) {
        target.focus();
      }
    });
  };
  if (typeof mobileFilters.addEventListener === 'function') {
    mobileFilters.addEventListener('change', handleFilterModeChange);
  } else {
    mobileFilters.addListener(handleFilterModeChange);
  }
  updateFilterUi();
  syncFilterMode();
  root.dataset.filtersReady = 'true';

  // Singles-ronde 25-09-2026 ---------------------------------------------------------
  // 1. Automatisch doorladen: de volgende pagina laadt al als "Meer laden" in beeld komt
  //    (maximaal 3 keer per zoekopdracht; daarna blijft de knop gewoon werken).
  //    Scroll anchoring staat op deze pagina uit: anders springt de browser bij snel scrollen
  //    mee naar de knop/footer en komen de nieuwe kaarten boven beeld terecht.
  document.documentElement.style.overflowAnchor = 'none';
  document.body.style.overflowAnchor = 'none';
  const AUTO_LOAD_LIMIT = 3;
  if (remoteSearchEnabled && 'IntersectionObserver' in window) {
    new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      if (els.loadMore.hidden || els.loadMore.disabled || state.remotePending || !state.remoteReady) return;
      if (autoLoadCount >= AUTO_LOAD_LIMIT || state.shown >= state.total) return;
      autoLoadCount += 1;
      void requestRemoteSearch({ append: true });
    }, { rootMargin: '0px 0px 700px 0px' }).observe(els.loadMore);
  }

  // 2. Zwevende filterknop + "terug naar boven" op mobiel, zodra de werkbalk uit beeld is.
  const dock = root.querySelector('[data-index-dock]');
  if (dock) {
    const toolbar = root.querySelector('.lc-index__toolbar');
    const results = root.querySelector('.lc-index__results');
    let toolbarPassed = false;
    let resultsInView = false;
    const syncDock = () => {
      dock.hidden = !(mobileFilters.matches && toolbarPassed && resultsInView);
    };
    if (toolbar && results && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        const entry = entries[entries.length - 1];
        toolbarPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        syncDock();
      }).observe(toolbar);
      new IntersectionObserver((entries) => {
        resultsInView = entries.some((entry) => entry.isIntersecting);
        syncDock();
      }, { rootMargin: '0px 0px -40% 0px' }).observe(results);
    }
    if (typeof mobileFilters.addEventListener === 'function') mobileFilters.addEventListener('change', syncDock);
    dock.querySelector('[data-index-dock-filters]')?.addEventListener('click', openFilters);
    dock.querySelector('[data-index-dock-top]')?.addEventListener('click', () => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      root.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  }

  // 3. "/" zet de cursor in het zoekveld (zoals op veel kaartsites).
  document.addEventListener('keydown', (event) => {
    if (event.key !== '/' || event.defaultPrevented || event.ctrlKey || event.metaKey || event.altKey || event.isComposing) return;
    const target = event.target;
    if (target instanceof Element && target.closest('input, textarea, select, [contenteditable=""], [contenteditable="true"]')) return;
    if (root.classList.contains('is-filters-open')) return;
    event.preventDefault();
    els.search.focus();
    els.search.select();
  });

  // 4. Kaart kantelen + holo-glans volgt de muis (alleen muis, niet bij "minder beweging").
  const tiltQuery = window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  let tiltTarget = null;
  let tiltPoint = null;
  let tiltFrame = 0;
  const resetTilt = () => {
    if (tiltTarget) {
      tiltTarget.classList.remove('is-tilting');
      ['--mx', '--my', '--rx', '--ry'].forEach((property) => tiltTarget.style.removeProperty(property));
    }
    tiltTarget = null;
  };
  const paintTilt = () => {
    tiltFrame = 0;
    if (!tiltTarget || !tiltPoint) return;
    const rect = tiltTarget.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    const x = Math.min(1, Math.max(0, (tiltPoint.x - rect.left) / rect.width));
    const y = Math.min(1, Math.max(0, (tiltPoint.y - rect.top) / rect.height));
    tiltTarget.style.setProperty('--mx', `${(x * 100).toFixed(1)}%`);
    tiltTarget.style.setProperty('--my', `${(y * 100).toFixed(1)}%`);
    tiltTarget.style.setProperty('--rx', `${((0.5 - y) * 12).toFixed(2)}deg`);
    tiltTarget.style.setProperty('--ry', `${((x - 0.5) * 14).toFixed(2)}deg`);
    tiltTarget.classList.add('is-tilting');
  };
  els.grid.addEventListener('pointermove', (event) => {
    if (event.pointerType !== 'mouse' || !tiltQuery.matches) return;
    const target = event.target instanceof Element ? event.target.closest('.lc-index-card__image') : null;
    if (target !== tiltTarget) resetTilt();
    if (!target || target.closest('.lc-index-card--skeleton')) return;
    tiltTarget = target;
    tiltPoint = { x: event.clientX, y: event.clientY };
    if (!tiltFrame) tiltFrame = window.requestAnimationFrame(paintTilt);
  }, { passive: true });
  els.grid.addEventListener('pointerleave', resetTilt);

  if (els.eyebrow) {
    els.eyebrow.textContent = T.inStockTotal.replace(
      '{count}',
      manifestTotalAvailable.toLocaleString(numberLocale),
    );
  }
  updateGameCounts([], false);
  // Restore controls before any asynchronous index request can finish. A later
  // response must not overwrite a query or history navigation made while loading.
  viewRestored = restoreSavedView(savedView, { applyNow: false });
  persistView();
  showActiveGame();
  init();
})();
